/* cache-bust-1746478000 */
(function () {
  var sections = document.querySelectorAll('[data-dept-section]');
  if (!sections.length) return;

  var DEFAULT_COLOR_OPTION_NAMES = ['color', 'colour'];
  var healixColorCodeCache = {};
  var DEPT_SIZE_CHART_FULL_HTML = '<!DOCTYPE html><html><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"><link href="https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap" rel="stylesheet"></head><body>' +
    '<div id="sizeChartModal" style="display:block;position:static;background:none;width:100%;height:100%;">' +
    '<div class="modal-content" style="margin:0;max-height:none;width:100%;max-width:none;border-radius:0;height:100%;overflow-y:auto;">' +
    '<span id="closeModal">&times;</span>' +
    '<h2 class="size-heading"></h2>' +
    '<div class="toggle-switch" id="unitToggle">' +
    '<span class="label cm-label">CM</span>' +
    '<div class="switch"><div class="knob"></div></div>' +
    '<span class="label in-label active">IN</span>' +
    '</div>' +
    '<div class="table-wrapper"><table id="sizeTableIn" class="size-table"></table></div>' +
    '<div class="table-wrapper"><table id="sizeTableCm" class="size-table" style="display:none;"></table></div>' +
    '<div class="inseam-container">' +
    '<div class="inseam-section"><table class="inseam-table-in jogger inseam-table"></table><table class="inseam-table-cm jogger inseam-table" style="display:none;"></table></div>' +
    '<div class="inseam-section"><table class="inseam-table pantin"></table><table class="inseam-table pantcm" style="display:none;"></table></div>' +
    '<div class="inseam-section"><table class="inseam-table jumpsuitin"></table><table class="inseam-table jumpsuitcm" style="display:none;"></table></div>' +
    '</div>' +
    '<div class="how-to-measure"></div>' +
    '</div></div>' +
    '<style>' +
    '.table-wrapper { overflow-x: auto; border: 1px solid #ddd; border-radius: 8px; box-shadow: 0 2px 6px rgba(0,0,0,0.08); }' +
    '.size-table { border-collapse: collapse; width: 100%; min-width: 600px; font-family: "Poppins", sans-serif; font-size: 14px; }' +
    '.size-table th, .size-table td { padding: 10px 14px; border: 1px solid #ddd; text-align: center; white-space: nowrap; }' +
    '.size-table thead th { position: sticky; top: 0; background: #f9f9f9; z-index: 1; font-weight: 600; }' +
    '.size-table tbody tr:hover { background: #f1f1f1; }' +
    '#sizeChartModal, #sizeChartModal * { font-family: "Poppins", sans-serif; }' +
    '.modal-content { background: #fff; padding: s0px; position: relative; }' +
    '#closeModal { position: absolute; top: 15px; right: 20px; font-size: 28px; cursor: pointer; }' +
    '.toggle-switch { display: flex; align-items: center; gap: 10px; margin-bottom: 15px; font-weight: 600; font-size: 14px; flex-direction: row-reverse; }' +
    '.toggle-switch .label { cursor: pointer; color: #888; transition: color 0.3s ease; }' +
    '.toggle-switch .label.active { color: #000; }' +
    '.switch { position: relative; width: 50px; height: 24px; background: #ddd; border-radius: 50px; cursor: pointer; transition: background 0.3s ease; }' +
    '.knob { position: absolute; top: 2px; left: 2px; width: 20px; height: 20px; background: #fff; border-radius: 50%; box-shadow: 0 2px 4px rgba(0,0,0,0.2); transition: transform 0.3s ease; }' +
    '.switch.active { background: #b7b7b7; }' +
    '.switch.active .knob { transform: translateX(26px); }' +
    '.size-table { width: 100%; border-collapse: collapse; }' +
    '.size-table th, .size-table td { border: 1px solid #ddd; padding: 8px; text-align: center; }' +
    '.size-table thead { background: #f4f4f4; }' +
    '.how-to-measure { display: flex; flex-wrap: wrap; background-color: #f6f6f6; padding: 40px 20px; gap: 30px; justify-content: center; align-items: center; margin-top: 30px; }' +
    '.measure-image { flex: 1 1 300px; max-width: 400px; text-align: center; }' +
    '.measure-text { flex: 1 1 300px; max-width: 500px; }' +
    '.measure-text h2 { font-size: 24px; font-weight: 600; margin-bottom: 10px; }' +
    '.measure-text ul { list-style: none; padding: 0; margin: 0; }' +
    '.measure-text li { margin-bottom: 20px; font-size: 16px; line-height: 1.6; }' +
    '.inseam-container { margin: 20px 0; padding: 20px; border-radius: 8px; display: flex; }' +
    '@media (max-width: 650px) { .inseam-container { display: block !important; } }' +
    '.inseam-table { width: 100%; border-collapse: collapse; font: 14px "Poppins", sans-serif; text-align: center; }' +
    '.inseam-table th, .inseam-table td { padding: 10px; border: 1px solid #ddd; }' +
    '.inseam-table thead { background: #f4f4f4; }' +
    '.inseam-table td:first-child { font-weight: 500; background: #fafafa; text-align: left; }' +
    '.inseam-section { max-width: 400px; margin: auto; margin-top: 30px; }' +
    '.measure-image img { max-width: 100%; height: auto; }' +
    '</style>' +
    '<script>' +
    'var tableIn=document.getElementById("sizeTableIn");' +
    'var tableCm=document.getElementById("sizeTableCm");' +
    'var sizeHeading=document.querySelector(".size-heading");' +
    'var toggleContainer=document.getElementById("unitToggle");' +
    'var switchEl=toggleContainer.querySelector(".switch");' +
    'var inLabel=toggleContainer.querySelector(".in-label");' +
    'var cmLabel=toggleContainer.querySelector(".cm-label");' +
    'var inseamContainer=document.querySelector(".inseam-container");' +
    'var inseam_table_in=document.querySelector(".inseam-table-in");' +
    'var inseam_table_cm=document.querySelector(".inseam-table-cm");' +
    'var pantin=document.querySelector(".pantin");' +
    'var pantcm=document.querySelector(".pantcm");' +
    'var jumpsuitin=document.querySelector(".jumpsuitin");' +
    'var jumpsuitcm=document.querySelector(".jumpsuitcm");' +
    'document.getElementById("closeModal").onclick=function(){parent.postMessage("dept-size-chart-close","*")};' +
    'switchEl.addEventListener("click",function(){' +
    'switchEl.classList.toggle("active");' +
    'if(switchEl.classList.contains("active")){' +
    'tableIn.style.display="none";tableCm.style.display="table";cmLabel.classList.add("active");inLabel.classList.remove("active");' +
    'inseam_table_in.style.display="none";inseam_table_cm.style.display="table";' +
    'pantin.style.display="none";pantcm.style.display="table";' +
    'jumpsuitin.style.display="none";jumpsuitcm.style.display="table";' +
    '}else{' +
    'tableIn.style.display="table";tableCm.style.display="none";inLabel.classList.add("active");cmLabel.classList.remove("active");' +
    'inseam_table_in.style.display="table";inseam_table_cm.style.display="none";' +
    'pantin.style.display="table";pantcm.style.display="none";' +
    'jumpsuitin.style.display="table";jumpsuitcm.style.display="none";' +
    '}});' +
    'function displaySizeChart(productType){' +
    'var currentProductType=productType;' +
    'var inchTable=document.getElementById("sizeTableIn");' +
    'var cmTable=document.getElementById("sizeTableCm");' +
    'var measure=document.querySelector(".how-to-measure");' +
    'cmTable.style.display="none";inchTable.style.display="table";' +
    'switchEl.classList.remove("active");inLabel.classList.add("active");cmLabel.classList.remove("active");' +
    'inseam_table_in.style.display="table";inseam_table_cm.style.display="none";' +
    'pantin.style.display="table";pantcm.style.display="none";' +
    'jumpsuitin.style.display="table";jumpsuitcm.style.display="none";' +
    'var inTableHtml="",cmTableHtml="",measureHtml="",sizeHeadingText="";' +
    'if(currentProductType&&currentProductType.toLowerCase()==="women tops"){' +
    'sizeHeadingText="Women\\\'s Top";' +
    'inTableHtml=\'<thead><tr><th>Size</th><th>XXS</th><th>XS</th><th>S</th><th>M</th><th>L</th><th>XL</th><th>2XL</th><th>3XL</th><th>4XL</th><th>5XL</th></tr></thead><tbody><tr><td>Bust</td><td>33.5</td><td>37.5</td><td>39.5</td><td>41.5</td><td>44</td><td>47</td><td>50.5</td><td>54.5</td><td>58.5</td><td>62.5</td></tr><tr><td>Waist</td><td>33</td><td>35</td><td>37</td><td>39</td><td>41.5</td><td>44.5</td><td>48</td><td>52</td><td>56</td><td>60</td></tr><tr><td>Sweep</td><td>37.5</td><td>39.5</td><td>41.5</td><td>43.5</td><td>46.5</td><td>50</td><td>54</td><td>58</td><td>62</td><td>66.5</td></tr></tbody>\';' +
    'cmTableHtml=\'<thead><tr><th>Size</th><th>XXS</th><th>XS</th><th>S</th><th>M</th><th>L</th><th>XL</th><th>2XL</th><th>3XL</th><th>4XL</th><th>5XL</th></tr></thead><tbody><tr><td>Bust</td><td>85.09</td><td>95.3</td><td>100.3</td><td>105.4</td><td>111.8</td><td>119.4</td><td>128.3</td><td>138.4</td><td>148.6</td><td>158.8</td></tr><tr><td>Waist</td><td>83.8</td><td>88.9</td><td>94.0</td><td>99.1</td><td>105.4</td><td>113.0</td><td>121.9</td><td>132.1</td><td>142.2</td><td>152.4</td></tr><tr><td>Sweep</td><td>95.3</td><td>100.3</td><td>105.4</td><td>110.5</td><td>118.1</td><td>127.0</td><td>137.2</td><td>147.3</td><td>157.5</td><td>168.9</td></tr></tbody>\';' +
    'measureHtml=\'<div class="measure-image"><img src="https://cdn.shopify.com/s/files/1/0928/8869/5155/files/WhatsApp_Image_2025-09-09_at_10.42.16_AM_3.png?v=1757914211" alt="How to Measure Illustration"></div><div class="measure-text"><h2>How To Measure</h2><ul><li><strong>BUST</strong> Measure around the fullest part of your bust</li><li><strong>WAIST</strong> Measure around the smallest part of your waist</li><li><strong>SWEEP</strong> Measure around the fullest part of your hip</li></ul></div>\';' +
    'inseamContainer.innerHTML="";inseamContainer.style.display="none";' +
    '}else if(currentProductType&&(currentProductType.toLowerCase()==="women pants"||currentProductType.toLowerCase()==="women joggers")){' +
    'sizeHeadingText="Women\\\'s Pants";' +
    'inTableHtml=\'<thead><tr><th>Size</th><th>XXS</th><th>XS</th><th>S</th><th>M</th><th>L</th><th>XL</th><th>XXL</th><th>3XL</th><th>4XL</th><th>5XL</th></tr></thead><tbody><tr><td>Waist</td><td>27</td><td>29</td><td>31</td><td>33</td><td>36</td><td>39</td><td>43</td><td>47</td><td>51</td><td>56</td></tr><tr><td>Hip</td><td>40</td><td>42</td><td>44</td><td>47</td><td>50</td><td>53</td><td>57</td><td>61</td><td>66</td><td>71</td></tr></tbody>\';' +
    'cmTableHtml=\'<thead><tr><th>Size</th><th>XXS</th><th>XS</th><th>S</th><th>M</th><th>L</th><th>XL</th><th>2XL</th><th>3XL</th><th>4XL</th><th>5XL</th></tr></thead><tbody><tr><td>Waist</td><td>68.6</td><td>73.7</td><td>78.7</td><td>83.8</td><td>91.4</td><td>99.1</td><td>109.2</td><td>119.4</td><td>129.5</td><td>142.2</td></tr><tr><td>Hip</td><td>101.6</td><td>106.7</td><td>111.8</td><td>119.4</td><td>127.0</td><td>134.6</td><td>144.8</td><td>154.9</td><td>167.6</td><td>180.3</td></tr></tbody>\';' +
    'measureHtml=\'<div class="measure-image"><img src="https://cdn.shopify.com/s/files/1/0928/8869/5155/files/Measurement_details_2_167e807b-9618-473f-8343-44cec0e91875.png?v=1757915735" alt="How to Measure Illustration"></div><div class="measure-text"><h2>How To Measure</h2><ul><li><strong>INSEAM</strong> Measure from the top of your inner thigh down to the bottom of your ankle along the inside of your leg.</li><li><strong>WAIST</strong> Measure around the smallest part of your waist</li><li><strong>HIP</strong> Measure around the fullest part of your hip</li></ul></div>\';' +
    'inseam_table_in.innerHTML=\'<thead><tr><th colspan="2">INSEAM LENGTH JOGGERS</th></tr></thead><tbody><tr><td>PETITE</td><td>26</td></tr><tr><td>REGULAR</td><td>29</td></tr><tr><td>TALL</td><td>31</td></tr></tbody>\';' +
    'inseam_table_cm.innerHTML=\'<thead><tr><th colspan="2">INSEAM LENGTH JOGGERS</th></tr></thead><tbody><tr><td>PETITE</td><td>66</td></tr><tr><td>REGULAR</td><td>74</td></tr><tr><td>TALL</td><td>79</td></tr></tbody>\';' +
    'pantin.innerHTML=\'<thead><tr><th>Inseam Length</th><th>Cargo</th><th>Slim</th></tr></thead><tbody><tr><td>Petite</td><td>29</td><td>27</td></tr><tr><td>Regular</td><td>31</td><td>30</td></tr><tr><td>Tall</td><td>34</td><td>33</td></tr></tbody>\';' +
    'pantcm.innerHTML=\'<thead><tr><th>Inseam Length</th><th>Cargo</th><th>Slim</th></tr></thead><tbody><tr><td>Petite</td><td>74</td><td>69</td></tr><tr><td>Regular</td><td>79</td><td>76</td></tr><tr><td>Tall</td><td>86</td><td>84</td></tr></tbody>\';' +
    'inseamContainer.style.display="flex";' +
    '}else if(currentProductType&&currentProductType.toLowerCase()==="women jackets"){' +
    'sizeHeadingText="Women\\\'s Jacket";' +
    'inTableHtml=\'<thead><tr><th>Size</th><th>XXS</th><th>XS</th><th>S</th><th>M</th><th>L</th><th>XL</th><th>2XL</th><th>3XL</th><th>4XL</th><th>5XL</th></tr></thead><tbody><tr><td>Bust</td><td>36</td><td>38</td><td>40</td><td>42</td><td>44</td><td>46.5</td><td>49.5</td><td>52.5</td><td>56.5</td><td>60.5</td></tr><tr><td>Waist</td><td>33.5</td><td>35.5</td><td>37.5</td><td>39.5</td><td>41.5</td><td>44</td><td>47</td><td>50</td><td>54</td><td>58</td></tr><tr><td>Sweep</td><td>38</td><td>40</td><td>42</td><td>44</td><td>46</td><td>49</td><td>52</td><td>55.5</td><td>59.5</td><td>64</td></tr></tbody>\';' +
    'cmTableHtml=\'<thead><tr><th>Size</th><th>XXS</th><th>XS</th><th>S</th><th>M</th><th>L</th><th>XL</th><th>2XL</th><th>3XL</th><th>4XL</th><th>5XL</th></tr></thead><tbody><tr><td>Bust</td><td>91.4</td><td>96.5</td><td>101.6</td><td>106.7</td><td>111.8</td><td>118.1</td><td>125.7</td><td>133.4</td><td>143.5</td><td>153.7</td></tr><tr><td>Waist</td><td>85.1</td><td>90.2</td><td>95.3</td><td>100.3</td><td>105.4</td><td>111.8</td><td>119.4</td><td>127.0</td><td>137.2</td><td>147.3</td></tr><tr><td>Sweep</td><td>96.5</td><td>101.6</td><td>106.7</td><td>111.8</td><td>116.8</td><td>124.5</td><td>132.1</td><td>141.0</td><td>151.1</td><td>162.6</td></tr></tbody>\';' +
    'measureHtml=\'<div class="measure-image"><img src="https://cdn.shopify.com/s/files/1/0928/8869/5155/files/WhatsApp_Image_2025-09-09_at_10.42.16_AM_3.png?v=1757914211" alt="How to Measure Illustration"></div><div class="measure-text"><h2>How To Measure</h2><ul><li><strong>BUST</strong> Measure around the fullest part of your bust</li><li><strong>WAIST</strong> Measure around the smallest part of your waist</li><li><strong>SWEEP</strong> Measure around the fullest part of your sweep</li></ul></div>\';' +
    'inseamContainer.innerHTML="";inseamContainer.style.display="none";' +
    '}else if(currentProductType&&currentProductType.toLowerCase()==="women jumpsuits"){' +
    'sizeHeadingText="Women\\\'s Jumpsuit";' +
    'inTableHtml=\'<thead><tr><th>Size</th><th>XXS</th><th>XS</th><th>S</th><th>M</th><th>L</th><th>XL</th><th>2XL</th><th>3XL</th><th>4XL</th><th>5XL</th></tr></thead><tbody><tr><td>Bust</td><td>37</td><td>39</td><td>41</td><td>43</td><td>45</td><td>47.5</td><td>50.5</td><td>53.5</td><td>57.5</td><td>61.5</td></tr><tr><td>Waist</td><td>28.5</td><td>30.5</td><td>32.5</td><td>34.5</td><td>37.5</td><td>40.5</td><td>44.5</td><td>48.5</td><td>52.5</td><td>57.5</td></tr><tr><td>Hip</td><td>40</td><td>42</td><td>44</td><td>47</td><td>50</td><td>53</td><td>57</td><td>61</td><td>66</td><td>71</td></tr></tbody>\';' +
    'cmTableHtml=\'<thead><tr><th>Size</th><th>XXS</th><th>XS</th><th>S</th><th>M</th><th>L</th><th>XL</th><th>2XL</th><th>3XL</th><th>4XL</th><th>5XL</th></tr></thead><tbody><tr><td>Bust</td><td>94.0</td><td>99.1</td><td>104.1</td><td>109.2</td><td>114.3</td><td>120.7</td><td>128.3</td><td>135.9</td><td>146.1</td><td>156.2</td></tr><tr><td>Waist</td><td>72.4</td><td>77.5</td><td>82.6</td><td>87.6</td><td>95.3</td><td>102.9</td><td>113.0</td><td>123.2</td><td>133.4</td><td>146.1</td></tr><tr><td>Hip</td><td>101.6</td><td>106.7</td><td>111.8</td><td>119.4</td><td>127.0</td><td>134.6</td><td>144.8</td><td>154.9</td><td>167.6</td><td>180.3</td></tr></tbody>\';' +
    'measureHtml=\'<div class="measure-image"><img src="https://cdn.shopify.com/s/files/1/0928/8869/5155/files/Group_9.png?v=1757916929" alt="How to Measure Illustration"></div><div class="measure-text"><h2>How To Measure</h2><ul><li><strong>BUST</strong> Measure around the fullest part of your bust</li><li><strong>WAIST</strong> Measure around the smallest part of your waist</li><li><strong>HIP</strong> Measure around the fullest part of your hip</li><li><strong>INSEAM</strong> Measure from the top of your inner thigh down to the bottom of your ankle along the inside of your leg.</li></ul></div>\';' +
    'jumpsuitin.innerHTML=\'<thead><tr><th colspan="2">INSEAM LENGTH JUMPSUIT</th></tr></thead><tbody><tr><td>Petite</td><td>28</td></tr><tr><td>Regular</td><td>30</td></tr><tr><td>Tall</td><td>33</td></tr></tbody>\';' +
    'jumpsuitcm.innerHTML=\'<thead><tr><th colspan="2">INSEAM LENGTH JUMPSUIT</th></tr></thead><tbody><tr><td>Petite</td><td>71</td></tr><tr><td>Regular</td><td>76</td></tr><tr><td>Tall</td><td>84</td></tr></tbody>\';' +
    'inseamContainer.style.display="flex";' +
    '}else if(currentProductType&&currentProductType.toLowerCase()==="men tops"){' +
    'sizeHeadingText="Men\\\'s Tops";' +
    'inTableHtml=\'<thead><tr><th>Size</th><th>XS</th><th>S</th><th>M</th><th>L</th><th>XL</th><th>2XL</th><th>3XL</th><th>4XL</th><th>5XL</th></tr></thead><tbody><tr><td>Chest</td><td>40.5</td><td>42.5</td><td>44.5</td><td>47</td><td>49.5</td><td>52.5</td><td>55.5</td><td>59.5</td><td>63.5</td></tr><tr><td>Sweep</td><td>39.5</td><td>41.5</td><td>43.5</td><td>46</td><td>48.5</td><td>51.5</td><td>54.5</td><td>58.5</td><td>62.5</td></tr></tbody>\';' +
    'cmTableHtml=\'<thead><tr><th>Size</th><th>XS</th><th>S</th><th>M</th><th>L</th><th>XL</th><th>2XL</th><th>3XL</th><th>4XL</th><th>5XL</th></tr></thead><tbody><tr><td>Chest</td><td>102.9</td><td>108.0</td><td>113.0</td><td>119.4</td><td>125.7</td><td>133.4</td><td>141.0</td><td>151.1</td><td>161.3</td></tr><tr><td>Sweep</td><td>100.3</td><td>105.4</td><td>110.5</td><td>116.8</td><td>123.2</td><td>130.8</td><td>138.4</td><td>148.6</td><td>158.8</td></tr></tbody>\';' +
    'measureHtml=\'<div class="measure-image"><img src="https://cdn.shopify.com/s/files/1/0928/8869/5155/files/Group_11.png?v=1757927862" alt="How to Measure Illustration"></div><div class="measure-text"><h2>How To Measure</h2><ul><li><strong>CHEST</strong> Measure around the fullest part of your bust</li><li><strong>WAIST</strong> Measure around the smallest part of your waist</li></ul></div>\';' +
    'inseamContainer.innerHTML="";inseamContainer.style.display="none";' +
    '}else if(currentProductType&&currentProductType.toLowerCase()==="men pants"){' +
    'sizeHeadingText="Men\\\'s Pant";' +
    'inTableHtml=\'<thead><tr><th>Size</th><th>XS</th><th>S</th><th>M</th><th>L</th><th>XL</th><th>2XL</th><th>3XL</th><th>4XL</th><th>5XL</th></tr></thead><tbody><tr><td>Waist</td><td>29</td><td>31</td><td>33</td><td>36</td><td>39</td><td>43</td><td>47</td><td>51</td><td>56</td></tr><tr><td>Hip</td><td>42</td><td>44</td><td>47</td><td>50</td><td>53</td><td>57</td><td>62</td><td>67</td><td>73</td></tr><tr><td>INSEAM LENGTH REGULAR PANT</td><td>31</td><td>31</td><td>31</td><td>31</td><td>31</td><td>31</td><td>31</td><td>31</td><td>31</td></tr><tr><td>INSEAM LENGTH REGULAR JOGGERS</td><td>29</td><td>29</td><td>29</td><td>29</td><td>29</td><td>29</td><td>29</td><td>29</td><td>29</td></tr></tbody>\';' +
    'cmTableHtml=\'<thead><tr><th>Size</th><th>XS</th><th>S</th><th>M</th><th>L</th><th>XL</th><th>2XL</th><th>3XL</th><th>4XL</th><th>5XL</th></tr></thead><tbody><tr><td>Waist</td><td>73.66</td><td>78.74</td><td>83.82</td><td>91.44</td><td>99.06</td><td>109.22</td><td>119.38</td><td>129.54</td><td>142.24</td></tr><tr><td>Hip</td><td>106.68</td><td>111.76</td><td>119.38</td><td>127.00</td><td>134.62</td><td>144.78</td><td>157.48</td><td>170.18</td><td>185.42</td></tr><tr><td>INSEAM LENGTH REGULAR</td><td>78.74</td><td>78.74</td><td>78.74</td><td>78.74</td><td>78.74</td><td>78.74</td><td>78.74</td><td>78.74</td><td>78.74</td></tr></tbody>\';' +
    'measureHtml=\'<div class="measure-image"><img src="https://cdn.shopify.com/s/files/1/0928/8869/5155/files/pant.png?v=1757918762" alt="How to Measure Illustration"></div><div class="measure-text"><h2>How To Measure</h2><ul><li><strong>INSEAM</strong> Measure from the top of your inner thigh down to the bottom of your ankle along the inside of your leg.</li><li><strong>WAIST</strong> Measure around the smallest part of your waist</li><li><strong>HIP</strong> Measure around the fullest part of your hip</li></ul></div>\';' +
    'inseamContainer.innerHTML="";inseamContainer.style.display="none";' +
    '}else if(currentProductType&&currentProductType.toLowerCase()==="men jackets"){' +
    'sizeHeadingText="Men\\\'s Jacket";' +
    'inTableHtml=\'<thead><tr><th>Size</th><th>XS</th><th>S</th><th>M</th><th>L</th><th>XL</th><th>2XL</th><th>3XL</th><th>4XL</th><th>5XL</th></tr></thead><tbody><tr><td>Chest</td><td>40</td><td>42</td><td>44</td><td>46.5</td><td>49</td><td>52</td><td>55</td><td>59</td><td>63</td></tr><tr><td>Waist</td><td>40</td><td>42</td><td>44</td><td>46.5</td><td>49</td><td>52</td><td>55</td><td>59</td><td>63</td></tr><tr><td>Sweep</td><td>40</td><td>42</td><td>44</td><td>46.5</td><td>49</td><td>52</td><td>55</td><td>59</td><td>63</td></tr></tbody>\';' +
    'cmTableHtml=\'<thead><tr><th>Size</th><th>XS</th><th>S</th><th>M</th><th>L</th><th>XL</th><th>2XL</th><th>3XL</th><th>4XL</th><th>5XL</th></tr></thead><tbody><tr><td>Chest</td><td>101.6</td><td>106.68</td><td>111.76</td><td>118.11</td><td>124.46</td><td>132.08</td><td>139.7</td><td>149.86</td><td>160.02</td></tr><tr><td>Waist</td><td>101.6</td><td>106.68</td><td>111.76</td><td>118.11</td><td>124.46</td><td>132.08</td><td>139.7</td><td>149.86</td><td>160.02</td></tr><tr><td>Sweep</td><td>101.6</td><td>106.68</td><td>111.76</td><td>118.11</td><td>124.46</td><td>132.08</td><td>139.7</td><td>149.86</td><td>160.02</td></tr></tbody>\';' +
    'measureHtml=\'<div class="measure-image"><img src="https://cdn.shopify.com/s/files/1/0928/8869/5155/files/JACKK.png?v=1758036203" alt="How to Measure Illustration"></div><div class="measure-text"><h2>How To Measure</h2><ul><li><strong>CHEST</strong> Measure around the fullest part of your bust</li><li><strong>WAIST</strong> Measure around the smallest part of your waist</li><li><strong>SWEEP</strong> Measure around the bottom hem of a garment</li></ul></div>\';' +
    'inseamContainer.innerHTML="";inseamContainer.style.display="none";' +
    '}' +
    'inchTable.innerHTML=inTableHtml;cmTable.innerHTML=cmTableHtml;measure.innerHTML=measureHtml;sizeHeading.innerHTML=sizeHeadingText;' +
    '}' +
    'displaySizeChart("__PRODUCT_TYPE__");' +
    '<\/script></body></html>';

  sections.forEach(initSection);

  function initSection(section) {
    var pills = Array.prototype.slice.call(section.querySelectorAll('.dept__pill[data-group-key]'));
    var groups = Array.prototype.slice.call(section.querySelectorAll('.dept__group[data-group-key]'));
    var activeLabel = section.querySelector('.dept__active-label');
    var productsLabel = section.querySelector('.dept__products-label');
    var productsRow = section.querySelector('.dept__products-row');
    var pdpArea = section.querySelector('.dept__pdp');
    var setupNote = section.querySelector('.dept__setup-note');

    var collectionsLimit = parseInt(section.dataset.collectionsLimit, 10) || 0;
    var productsLimit = parseInt(section.dataset.productsLimit, 10) || 8;
    var colorOptionNames = parseColorOptionNames(section.dataset.colorOptionNames);
    var currentCollectionProducts = [];
    var dedupColors = section.dataset.dedupColors === 'true';
    var syncPDPThumbRailOnResize = null;
    var activePdpVisibilityHandler = null;
    var healixColorSiblingsCache = {};
    var collectionProductsCache = {};
    var collectionProductsFetchCache = {};
    var collectionProductsReadyState = {};
    var productJsonCache = {};
    var productJsonFetchCache = {};
    var ratingCache = {};
    var videoCache = {};
    var accordionContentCache = {};
    var htmlFetchCache = {};
    var latestProductsRequestToken = 0;
    var latestPdpRequestToken = 0;
    var COLLECTION_PRODUCTS_FETCH_LIMIT = 16;
    var PREFETCH_MAX_CONCURRENCY = 6;
    var PREFETCH_PRODUCT_WARM_LIMIT = 6;
    var prefetchQueue = [];
    var prefetchQueueKeys = {};
    var prefetchRunningCount = 0;
    var prefetchDrainScheduled = false;
    var discoveryWarmupStarted = false;

    var typeCardsActive = false;
    var savedCategoryHTML = '';
    var currentCustomProductImage = '';
    var savedCategoryGroup = null;
    var activeCollectionTitle = '';
    var savedDepartmentLabel = '';

    if (!pills.length && groups.length) {
      var pillsContainer = section.querySelector('.dept__pills');
      if (!pillsContainer) {
        pillsContainer = document.createElement('div');
        pillsContainer.className = 'dept__pills';
        pillsContainer.setAttribute('role', 'tablist');
        pillsContainer.setAttribute('aria-label', 'Departments');
        var insertBeforeNode = groups[0];
        if (insertBeforeNode && insertBeforeNode.parentNode) {
          insertBeforeNode.parentNode.insertBefore(pillsContainer, insertBeforeNode);
          if (!activeLabel) {
            var labelRow = document.createElement('div');
            labelRow.className = 'dept__label-row';
            activeLabel = document.createElement('h3');
            activeLabel.className = 'dept__active-label';
            labelRow.appendChild(activeLabel);
            insertBeforeNode.parentNode.insertBefore(labelRow, insertBeforeNode);
          }
        } else {
          section.appendChild(pillsContainer);
        }
      }

      groups.forEach(function (group, index) {
        var key = group.dataset.groupKey || '';
        var label = group.dataset.groupLabel || ('Department ' + (index + 1));
        if (!key) return;

        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'dept__pill';
        if (group.hasAttribute('data-default-active') || index === 0) {
          button.classList.add('dept__pill--active');
        }
        button.dataset.groupKey = key;
        button.dataset.groupLabel = label;
        button.setAttribute('role', 'tab');
        button.setAttribute('aria-selected', button.classList.contains('dept__pill--active') ? 'true' : 'false');
        button.textContent = label;
        pillsContainer.appendChild(button);
      });

      pills = Array.prototype.slice.call(section.querySelectorAll('.dept__pill[data-group-key]'));
    }

    if (!pills.length || !groups.length) {
      return;
    }

    groups.forEach(function (group) {
      syncGroupCollectionMode(group);
    });

    var pillsContainer = section.querySelector('.dept__pills');
    var pillsContainerStyle = pillsContainer ? window.getComputedStyle(pillsContainer) : null;

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var key = pill.dataset.groupKey || '';
        var label = pill.dataset.groupLabel || pill.textContent.trim();
        setActiveGroup(key, label, true);
      });
    });

    groups.forEach(function (group) {
      group.addEventListener('click', function (event) {
        var card = event.target.closest('.dept__collection-card[data-collection-handle]');
        if (!card || !group.contains(card) || card.classList.contains('is-hidden-by-limit')) return;

        event.preventDefault();
        var handle = card.dataset.collectionHandle;
        var title = card.dataset.collectionTitle || getText(card, '.dept__collection-title');
        currentCustomProductImage = card.dataset.customProductImage || '';

        setActiveCollectionCard(group, card);

        if (handle) {
          fetchProducts(handle, title, false, true);
          prefetchSiblingCollections(group, handle);
        }
      });
    });

    var isInitialLoad = true;

    function setGroupCollectionMode(group, enabled) {
      if (!group) return;
      group.classList.toggle('dept__group--collection-mode', !!enabled);
    }

    function syncGroupCollectionMode(group) {
      if (!group) return;
      var hasCollectionCards = !!group.querySelector('.dept__collection-card[data-collection-handle]');
      setGroupCollectionMode(group, hasCollectionCards);
    }

    function setActiveCollectionCard(group, activeCard) {
      if (!group) return;
      var cards = Array.prototype.slice.call(group.querySelectorAll('.dept__collection-card[data-collection-handle]'));
      cards.forEach(function (card) {
        card.classList.toggle('is-active', card === activeCard);
      });
    }

    function getFirstVisibleCollectionCard(group) {
      if (!group) return null;
      return group.querySelector('.dept__collection-card[data-collection-handle]:not(.is-hidden-by-limit)');
    }

    function ensureGroupCollectionSelection(group) {
      if (!group) return;
      var selectedVisibleCard = group.querySelector('.dept__collection-card.is-active:not(.is-hidden-by-limit)');
      if (selectedVisibleCard) {
        setActiveCollectionCard(group, selectedVisibleCard);
        return;
      }

      var firstVisibleCard = getFirstVisibleCollectionCard(group);
      if (firstVisibleCard) {
        setActiveCollectionCard(group, firstVisibleCard);
      }
    }

    function getStickyHeaderOffset() {
      var rootStyle = window.getComputedStyle(document.documentElement);
      var rawOffset = rootStyle.getPropertyValue('--untamed-fixed-header-offset') || '0';
      var parsedOffset = parseFloat(rawOffset);
      return isNaN(parsedOffset) ? 0 : parsedOffset;
    }

    function smoothScrollToElement(targetEl) {
      if (!targetEl) return;
      var targetRect = targetEl.getBoundingClientRect();
      var headerOffset = getStickyHeaderOffset();
      var spacing = 12;
      var targetTop = window.pageYOffset + targetRect.top - headerOffset - spacing;
      window.scrollTo({
        top: Math.max(0, targetTop),
        behavior: 'smooth'
      });
    }

    function scrollToTypeStep() {
      var activeGroup = groups.find(function (group) {
        return group.classList.contains('is-active');
      });
      if (!activeGroup) return;

      window.requestAnimationFrame(function () {
        var labelRow = activeLabel ? (activeLabel.closest('.dept__label-row') || activeLabel) : null;
        var typeTrack = activeGroup.querySelector('.dept__type-cards-track');
        smoothScrollToElement(labelRow || typeTrack || activeGroup);
      });
    }

    function scrollToProductsStep() {
      var target = null;
      if (productsLabel && productsLabel.textContent && productsLabel.textContent.trim()) {
        target = productsLabel;
      } else if (productsRow) {
        target = productsRow;
      }
      if (!target) return;

      window.requestAnimationFrame(function () {
        smoothScrollToElement(target);
      });
    }

    hydrateInlineDiscoveryCaches();

    var defaultPill = pills.find(function (pill) {
      return pill.classList.contains('dept__pill--active');
    }) || pills[0];

    setActiveGroup(
      defaultPill.dataset.groupKey || '',
      defaultPill.dataset.groupLabel || defaultPill.textContent.trim(),
      true
    );

    isInitialLoad = false;
    scheduleInitialDiscoveryWarmup();

    function setActiveGroup(groupKey, label, resetDownstream) {
      pills.forEach(function (pill) {
        var isActive = (pill.dataset.groupKey || '') === groupKey;
        pill.classList.toggle('dept__pill--active', isActive);
        pill.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      groups.forEach(function (group) {
        var isActive = (group.dataset.groupKey || '') === groupKey;
        group.classList.toggle('is-active', isActive);
        if (isActive) {
          group.removeAttribute('hidden');
          applyCollectionLimit(group);
        } else {
          group.setAttribute('hidden', '');
        }
        syncGroupCollectionMode(group);
      });

      if (activeLabel) activeLabel.textContent = label || '';
      var activeGroup = groups.find(function (group) {
        return group.classList.contains('is-active');
      });
      var activeCards = activeGroup ? activeGroup.querySelectorAll('.dept__collection-card').length : 0;
      var activeCardsHiddenByLimit = activeGroup ? activeGroup.querySelectorAll('.dept__collection-card.is-hidden-by-limit').length : 0;
      
      if (resetDownstream) {
        restoreTypeCards();
        if (activeGroup) {
          var firstCard = getFirstVisibleCollectionCard(activeGroup);
          if (firstCard) {
            setActiveCollectionCard(activeGroup, firstCard);
            var handle = firstCard.dataset.collectionHandle;
            var title = firstCard.dataset.collectionTitle || getText(firstCard, '.dept__collection-title');
            currentCustomProductImage = firstCard.dataset.customProductImage || '';
            if (handle) {
              fetchProducts(handle, title, isInitialLoad, false);
              prefetchSiblingCollections(activeGroup, handle);
            }
          }
        }
      } else if (activeGroup) {
        ensureGroupCollectionSelection(activeGroup);
      }

      if (activeGroup) {
        window.setTimeout(function () {
          refreshScrollProgress(activeGroup);
        }, 50);
      }
    }

    function applyCollectionLimit(group) {
      var cards = Array.prototype.slice.call(group.querySelectorAll('.dept__collection-card'));
      cards.forEach(function (card, index) {
        var hide = collectionsLimit > 0 && index >= collectionsLimit;
        card.classList.toggle('is-hidden-by-limit', hide);
      });
      ensureGroupCollectionSelection(group);
    }

    function clearProducts() {
      currentCollectionProducts = [];
      if (productsLabel) productsLabel.textContent = '';
      if (productsRow) productsRow.innerHTML = '';
      refreshProductsRowProgress();
    }

    function clearPDP() {
      if (activePdpVisibilityHandler) {
        document.removeEventListener('visibilitychange', activePdpVisibilityHandler);
        activePdpVisibilityHandler = null;
      }
      if (pdpArea) pdpArea.innerHTML = '';
    }

    function schedulePrefetchDrain(forceSoon) {
      if (prefetchDrainScheduled) return;
      prefetchDrainScheduled = true;

      function runDrain() {
        prefetchDrainScheduled = false;
        drainPrefetchQueue();
      }

      if (forceSoon) {
        window.setTimeout(runDrain, 0);
        return;
      }

      if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(runDrain, { timeout: 900 });
      } else {
        window.setTimeout(runDrain, 120);
      }
    }

    function queuePrefetchTask(key, task, options) {
      options = options || {};
      if (!key || typeof task !== 'function' || prefetchQueueKeys[key]) return;
      prefetchQueueKeys[key] = true;
      if (options.priority === 'high') {
        prefetchQueue.unshift({ key: key, task: task });
      } else {
        prefetchQueue.push({ key: key, task: task });
      }
      schedulePrefetchDrain(options.priority === 'high');
    }

    function drainPrefetchQueue() {
      while (prefetchRunningCount < PREFETCH_MAX_CONCURRENCY && prefetchQueue.length) {
        var nextTask = prefetchQueue.shift();
        delete prefetchQueueKeys[nextTask.key];
        prefetchRunningCount++;

        (function (taskFn) {
          Promise.resolve()
            .then(function () { return taskFn(); })
            .catch(function () {})
            .then(function () {
              prefetchRunningCount = Math.max(0, prefetchRunningCount - 1);
              if (prefetchQueue.length) {
                schedulePrefetchDrain();
              }
            });
        })(nextTask.task);
      }
      if (prefetchQueue.length && prefetchRunningCount >= PREFETCH_MAX_CONCURRENCY) {
        schedulePrefetchDrain();
      }
    }

    function toUniqueHandles(productsList, limit) {
      if (!Array.isArray(productsList) || !productsList.length) return [];
      var maxCount = typeof limit === 'number' && limit > 0 ? limit : productsList.length;
      var seen = {};
      var handles = [];

      for (var i = 0; i < productsList.length; i++) {
        var handle = String((productsList[i] && productsList[i].handle) || '').trim();
        if (!handle || seen[handle]) continue;
        seen[handle] = true;
        handles.push(handle);
        if (handles.length >= maxCount) break;
      }

      return handles;
    }

    function getGroupCollectionHandles(group, onlyVisible) {
      if (!group) return [];
      var cards = Array.prototype.slice.call(group.querySelectorAll('.dept__collection-card[data-collection-handle]'));
      var handles = [];
      var seen = {};

      cards.forEach(function (card, index) {
        if (onlyVisible && collectionsLimit > 0 && index >= collectionsLimit) return;
        var handle = String(card.dataset.collectionHandle || '').trim();
        if (!handle || seen[handle]) return;
        seen[handle] = true;
        handles.push(handle);
      });

      return handles;
    }

    function queueCollectionWarmup(handle, options) {
      options = options || {};
      var normalizedHandle = String(handle || '').trim();
      if (!normalizedHandle) return;
      var priority = options.priority === 'high' ? 'high' : 'normal';

      queuePrefetchTask('prefetch:collection-products:' + normalizedHandle, function () {
        return fetchCollectionProductsCached(normalizedHandle, { prefetch: true })
          .then(function (products) {
            if (!Array.isArray(products) || !products.length) return;
            prefetchProductDetails(products, { priority: priority, warmAll: true });
          });
      }, { priority: priority });
    }

    function startStagedDiscoveryWarmup() {
      if (discoveryWarmupStarted) return;
      discoveryWarmupStarted = true;

      var stageAHandles = [];
      var activeGroup = groups.find(function (group) {
        return group.classList.contains('is-active');
      });
      if (activeGroup) {
        stageAHandles = getGroupCollectionHandles(activeGroup, true);
        stageAHandles.forEach(function (handle) {
          queueCollectionWarmup(handle, { priority: 'high' });
        });
      }

      var stageASet = {};
      stageAHandles.forEach(function (handle) {
        stageASet[handle] = true;
      });

      groups.forEach(function (group) {
        getGroupCollectionHandles(group, false).forEach(function (handle) {
          if (stageASet[handle]) return;
          queueCollectionWarmup(handle, { priority: 'normal' });
        });
      });
    }

    function scheduleInitialDiscoveryWarmup() {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          startStagedDiscoveryWarmup();
        });
      });
    }

    function fetchCollectionProductsCached(collectionHandle, options) {
      options = options || {};
      var handle = String(collectionHandle || '').trim();
      if (!handle) return Promise.resolve([]);
      if (collectionProductsCache.hasOwnProperty(handle)) {
        collectionProductsReadyState[handle] = 'ready';
        return Promise.resolve(collectionProductsCache[handle]);
      }
      if (collectionProductsFetchCache[handle]) {
        return collectionProductsFetchCache[handle];
      }

      collectionProductsReadyState[handle] = 'loading';
      collectionProductsFetchCache[handle] = fetch('/collections/' + handle + '/products.json?limit=' + COLLECTION_PRODUCTS_FETCH_LIMIT)
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          var products = Array.isArray(data && data.products) ? data.products : [];
          collectionProductsCache[handle] = products;
          collectionProductsReadyState[handle] = 'ready';
          return products;
        })
        .catch(function (error) {
          collectionProductsReadyState[handle] = 'error';
          if (!options.prefetch) throw error;
          return [];
        })
        .then(function (products) {
          delete collectionProductsFetchCache[handle];
          return products;
        }, function (error) {
          delete collectionProductsFetchCache[handle];
          throw error;
        });

      return collectionProductsFetchCache[handle];
    }

    var allCollectionProductsCache = {};
    var allCollectionProductsFetchCache = {};

    function fetchAllCollectionProducts(collectionHandle) {
      var handle = String(collectionHandle || '').trim();
      if (!handle) return Promise.resolve([]);
      if (allCollectionProductsCache.hasOwnProperty(handle)) {
        return Promise.resolve(allCollectionProductsCache[handle]);
      }
      if (allCollectionProductsFetchCache[handle]) {
        return allCollectionProductsFetchCache[handle];
      }
      allCollectionProductsFetchCache[handle] = fetch('/collections/' + handle + '/products.json?limit=250')
        .then(function (response) { return response.json(); })
        .then(function (data) {
          var products = Array.isArray(data && data.products) ? data.products : [];
          allCollectionProductsCache[handle] = products;
          collectionProductsCache[handle] = products;
          collectionProductsReadyState[handle] = 'ready';
          return products;
        })
        .catch(function () { return []; })
        .then(function (products) {
          delete allCollectionProductsFetchCache[handle];
          return products;
        }, function (err) {
          delete allCollectionProductsFetchCache[handle];
          throw err;
        });
      return allCollectionProductsFetchCache[handle];
    }

    function fetchProductJsonCached(handle, options) {
      options = options || {};
      var normalizedHandle = String(handle || '').trim();
      if (!normalizedHandle) return Promise.resolve(null);
      if (productJsonCache[normalizedHandle]) {
        return Promise.resolve(productJsonCache[normalizedHandle]);
      }
      if (productJsonFetchCache[normalizedHandle]) {
        return productJsonFetchCache[normalizedHandle];
      }

      productJsonFetchCache[normalizedHandle] = fetch('/products/' + encodeURIComponent(normalizedHandle) + '.json')
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          var product = data && data.product ? data.product : null;
          if (product) {
            var productHandle = String(product.handle || normalizedHandle).trim();
            if (productHandle) {
              productJsonCache[productHandle] = product;
            }
            productJsonCache[normalizedHandle] = product;
          }
          return product;
        })
        .catch(function (error) {
          if (!options.prefetch) throw error;
          return null;
        })
        .then(function (product) {
          delete productJsonFetchCache[normalizedHandle];
          return product;
        }, function (error) {
          delete productJsonFetchCache[normalizedHandle];
          throw error;
        });

      return productJsonFetchCache[normalizedHandle];
    }

    function prefetchSiblingCollections(group, selectedHandle) {
      if (!group) return;
      var normalizedSelectedHandle = String(selectedHandle || '').trim();
      var handles = getGroupCollectionHandles(group, false);
      if (!handles.length) return;

      handles.forEach(function (handle) {
        if (handle === normalizedSelectedHandle) return;
        queueCollectionWarmup(handle, { priority: 'high' });
      });
    }

    function parseRatingFromProductHTML(html) {
      var data = { rating: 0, count: 0 };
      if (!html) return data;

      var match = html.match(/data-average-rating=['"]([0-9.]+)['"][\s\S]*?data-number-of-reviews=['"](\d+)['"]/);
      if (match) {
        data.rating = parseFloat(match[1]) || 0;
        data.count = parseInt(match[2], 10) || 0;
      }
      return data;
    }

    function normalizeAccordionTitle(value) {
      return String(value || '')
        .toLowerCase()
        .replace(/&/g, 'and')
        .replace(/\s+/g, ' ')
        .trim();
    }

    function parseAccordionContentFromProductHTML(html, heading) {
      if (!html) return '';

      var normalizedHeading = normalizeAccordionTitle(heading);
      if (!normalizedHeading) return '';

      try {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var accordions = doc.querySelectorAll('details.product-accordion-block');

        for (var i = 0; i < accordions.length; i++) {
          var accordion = accordions[i];
          var titleEl = accordion.querySelector('.product-accordion-block__title');
          var title = normalizeAccordionTitle(titleEl ? titleEl.textContent : '');
          if (title !== normalizedHeading) continue;

          var contentEl = accordion.querySelector('.product-accordion-block__content-inner');
          if (contentEl && typeof contentEl.innerHTML === 'string') {
            return contentEl.innerHTML.trim();
          }
        }
      } catch (e) {}

      return '';
    }

    function parseDiscoveryAccordionDataFromHTML(html) {
      return {
        fabric: parseAccordionContentFromProductHTML(html, 'Fabric & Care')
      };
    }

    function warmProductHTMLCaches(handle) {
      var normalizedHandle = String(handle || '').trim();
      if (!normalizedHandle) return Promise.resolve();
      if (
        videoCache[normalizedHandle] &&
        ratingCache[normalizedHandle] &&
        accordionContentCache.hasOwnProperty(normalizedHandle)
      ) return Promise.resolve();

      return fetchProductHTML(normalizedHandle).then(function (html) {
        if (!videoCache[normalizedHandle]) {
          videoCache[normalizedHandle] = parseVideosFromHTML(html);
        }
        if (!ratingCache[normalizedHandle]) {
          var ratingData = parseRatingFromProductHTML(html);
          if (ratingData.rating || ratingData.count) {
            ratingCache[normalizedHandle] = ratingData;
          }
        }
        if (!accordionContentCache.hasOwnProperty(normalizedHandle)) {
          accordionContentCache[normalizedHandle] = parseDiscoveryAccordionDataFromHTML(html);
        }
      }).catch(function () {});
    }

    function prefetchProductDetails(productsList, options) {
      options = options || {};
      var priority = options.priority === 'high' ? 'high' : 'normal';
      var primaryHandles = toUniqueHandles(productsList, PREFETCH_PRODUCT_WARM_LIMIT);
      if (!primaryHandles.length) return;

      primaryHandles.forEach(function (handle) {
        queuePrefetchTask('prefetch:product-json:' + handle, function () {
          return fetchProductJsonCached(handle, { prefetch: true });
        }, { priority: priority });
        if (!videoCache[handle] || !ratingCache[handle]) {
          queuePrefetchTask('prefetch:product-html:' + handle, function () {
            return warmProductHTMLCaches(handle);
          }, { priority: priority });
        }
      });

      if (!options.warmAll) return;
      var allHandles = toUniqueHandles(productsList, COLLECTION_PRODUCTS_FETCH_LIMIT);
      var primarySet = {};
      primaryHandles.forEach(function (handle) {
        primarySet[handle] = true;
      });
      allHandles.forEach(function (handle) {
        if (primarySet[handle]) return;
        queuePrefetchTask('prefetch:product-json:' + handle, function () {
          return fetchProductJsonCached(handle, { prefetch: true });
        }, { priority: 'normal' });
        if (!videoCache[handle] || !ratingCache[handle]) {
          queuePrefetchTask('prefetch:product-html:' + handle, function () {
            return warmProductHTMLCaches(handle);
          }, { priority: 'normal' });
        }
      });
    }

    function animateRowReveal(row) {
      if (!row) return;
      row.classList.remove('dept__row--reveal');
      window.requestAnimationFrame(function () {
        void row.offsetWidth;
        row.classList.add('dept__row--reveal');
      });
    }

    function refreshProductsRowProgress() {
      if (!productsRow) return;
      refreshScrollProgress(productsRow);
      window.requestAnimationFrame(function () {
        refreshScrollProgress(productsRow);
      });
      window.setTimeout(function () {
        refreshScrollProgress(productsRow);
      }, 120);
    }

    function bindProductsRowImageProgressRefresh() {
      if (!productsRow) return;
      var images = productsRow.querySelectorAll('img');
      Array.prototype.forEach.call(images, function (img) {
        if (!img || img.dataset.deptProgressBound === 'true') return;
        img.dataset.deptProgressBound = 'true';
        img.addEventListener('load', refreshProductsRowProgress, { passive: true });
        img.addEventListener('error', refreshProductsRowProgress, { passive: true });
      });
    }

    if (productsRow && typeof MutationObserver !== 'undefined') {
      var productsRowObserver = new MutationObserver(function () {
        bindProductsRowImageProgressRefresh();
        refreshProductsRowProgress();
      });
      productsRowObserver.observe(productsRow, { childList: true });
    }

    function fetchSiblingMap(handles) {
      if (!handles || !handles.length) return Promise.resolve({});

      var uncached = handles.filter(function (h) { return !healixColorSiblingsCache[h]; });
      if (!uncached.length) {
        return Promise.resolve(buildMapFromCache(handles));
      }

      return window.HealixColors.colorProductSiblings(uncached)
        .then(function (payload) {
          var result = payload && payload.result ? payload.result : {};
          var coreItems = Array.isArray(result.core) ? result.core : [];
          var leItems = Array.isArray(result.le) ? result.le : [];

          coreItems.concat(leItems).forEach(function (item) {
            if (!item || !item.variant) return;
            var parentHandle = String(item.handle || '').trim();
            var variantHandle = String(item.variant.handle || '').trim();
            if (parentHandle && variantHandle) {
              healixColorSiblingsCache[variantHandle] = parentHandle;
            }
          });

          uncached.forEach(function (h) {
            if (!healixColorSiblingsCache[h]) {
              healixColorSiblingsCache[h] = h;
            }
          });

          return buildMapFromCache(handles);
        })
        .catch(function () {
          return {};
        });
    }

    function buildMapFromCache(handles) {
      var map = {};
      handles.forEach(function (h) {
        map[h] = healixColorSiblingsCache[h] || h;
      });
      return map;
    }

    function restoreTypeCards() {
      if (!typeCardsActive) return;
      if (savedCategoryGroup && savedCategoryHTML) {
        savedCategoryGroup.innerHTML = savedCategoryHTML;
        savedCategoryGroup.classList.remove('dept__group--types-mode');
        savedCategoryGroup.classList.add('has-scroll-arrows', 'scroll-arrows-target');
        delete savedCategoryGroup.dataset.scrollArrowsBound;
        applyCollectionLimit(savedCategoryGroup);
        syncGroupCollectionMode(savedCategoryGroup);
        savedCategoryGroup.classList.remove('dept__group--reveal');
        window.requestAnimationFrame(function () {
          void savedCategoryGroup.offsetWidth;
          savedCategoryGroup.classList.add('dept__group--reveal');
        });
      }
      if (activeLabel && savedDepartmentLabel) {
        activeLabel.textContent = savedDepartmentLabel;
      }
      typeCardsActive = false;
      savedCategoryHTML = '';
      savedCategoryGroup = null;
      activeCollectionTitle = '';
      savedDepartmentLabel = '';
      removeBackLink();
    }

    function removeBackLink() {
      var existing = section.querySelector('.dept__back-link');
      if (existing) existing.remove();
    }

    function getActiveDepartmentLabel() {
      var activePill = pills.find(function (p) { return p.classList.contains('dept__pill--active'); });
      return activePill ? (activePill.dataset.groupLabel || activePill.textContent.trim()) : '';
    }

    function showBackLink() {
      removeBackLink();
      if (!activeLabel) return;
      var deptLabel = getActiveDepartmentLabel();
      var link = document.createElement('button');
      link.type = 'button';
      link.className = 'dept__back-link';
      link.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6"/></svg>Back to all ' + escapeHTML(deptLabel);
      link.addEventListener('click', function () {
        restoreTypeCards();
      });
      var labelRow = activeLabel.closest('.dept__label-row') || activeLabel.parentNode;
      labelRow.appendChild(link);
    }

    function renderTypeCards(typeGroups, allProducts, collectionTitle) {
      var activeGroup = groups.find(function (g) { return g.classList.contains('is-active'); });
      if (!activeGroup) return;

      savedCategoryHTML = activeGroup.innerHTML;
      savedCategoryGroup = activeGroup;
      typeCardsActive = true;
      activeCollectionTitle = collectionTitle;
      savedDepartmentLabel = activeLabel ? activeLabel.textContent : '';
      if (activeLabel) activeLabel.textContent = collectionTitle || '';

      var typeNames = Object.keys(typeGroups);

      var trackHTML = '<div class="dept__type-cards-wrap has-scroll-arrows"><div class="category-cards__track dept__type-cards-track scroll-arrows-target" style="padding:4px 2px;">';
      typeNames.forEach(function (typeName) {
        var group = typeGroups[typeName];
        var img = getProductImage(group.products[0]);
        trackHTML +=
          '<button type="button" class="category-card" data-type-card data-type-name="' + escapeHTML(typeName) + '">' +
            '<span class="category-card__image-wrap">' +
              (img
                ? '<img class="category-card__image" src="' + escapeHTML(resizeImage(img, 400)) + '" alt="' + escapeHTML(typeName) + '" loading="lazy" width="400" height="400">'
                : '<span class="category-card__skeleton category-card__skeleton--image"></span>') +
            '</span>' +
            '<span class="category-card__body">' +
              '<span class="category-card__title">' + escapeHTML(typeName) + '</span>' +
              '<span class="category-card__colors" data-type-colors="' + escapeHTML(typeName) + '">' +
                '<span class="category-card__skeleton category-card__skeleton--text"></span>' +
              '</span>' +
            '</span>' +
          '</button>';
      });
      trackHTML += '</div></div>';

      activeGroup.innerHTML = '<div class="category-cards" style="padding:0;">' + trackHTML + '</div>';
      setGroupCollectionMode(activeGroup, false);
      activeGroup.classList.add('dept__group--types-mode');
      activeGroup.classList.remove('has-scroll-arrows', 'scroll-arrows-target');
      delete activeGroup.dataset.scrollArrowsBound;
      activeGroup.classList.remove('dept__group--reveal');
      window.requestAnimationFrame(function () {
        void activeGroup.offsetWidth;
        activeGroup.classList.add('dept__group--reveal');
      });

      var typeCardButtons = Array.prototype.slice.call(activeGroup.querySelectorAll('[data-type-card]'));

      typeCardButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var typeName = btn.dataset.typeName;
          typeCardButtons.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
          if (productsLabel) productsLabel.textContent = typeName;
          var filtered = typeGroups[typeName] ? typeGroups[typeName].products : [];
          renderProductCardsForType(filtered);
        });
      });

      if (typeCardButtons.length > 0) {
        typeCardButtons[0].click();
      }

      showBackLink();
      hydrateTypeCardColors(typeGroups);
    }

    function hydrateTypeCardColors(typeGroups) {
      var handles = [];
      var handleSet = {};
      var typeNames = Object.keys(typeGroups);
      typeNames.forEach(function (typeName) {
        var h = typeGroups[typeName].products[0].handle;
        if (h && !handleSet[h]) {
          handleSet[h] = true;
          handles.push(h);
        }
      });
      if (!handles.length) return;

      window.HealixColors.colorProductSiblings(handles)
        .then(function (payload) {
          var result = payload && payload.result ? payload.result : {};
          var all = [].concat(result.core || [], result.le || []);
          var countMap = {};
          all.forEach(function (entry) {
            var v = entry && entry.variant ? entry.variant : {};
            var h = String(v.handle || '').trim();
            if (!h) return;
            handles.forEach(function (orig) {
              if (h === orig || h.startsWith(orig.replace(/-[^-]+$/, ''))) {
                if (!countMap[orig]) countMap[orig] = {};
                countMap[orig][String(v.color || '').toLowerCase()] = true;
              }
            });
          });

          var SWATCH_SVG = '<svg class="category-card__swatch-icon" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="6" cy="10" r="5" fill="#E84E4E"/><circle cx="10" cy="10" r="5" fill="#4EA0E8"/><circle cx="14" cy="10" r="5" fill="#5DC26D"/></svg>';

          typeNames.forEach(function (typeName) {
            var h = typeGroups[typeName].products[0].handle;
            var el = section.querySelector('[data-type-colors="' + typeName + '"]');
            if (!el || !countMap[h]) return;
            var n = Object.keys(countMap[h]).length;
            if (n > 0) el.innerHTML = SWATCH_SVG + n + (n === 1 ? ' color' : ' colors');
          });
        })
        .catch(function () {});
    }

    function renderProductCardsForType(productsList) {
      if (!productsRow) return;
      var visibleProducts = productsLimit > 0 ? productsList.slice(0, productsLimit) : productsList;
      prefetchProductDetails(visibleProducts);
      if (!visibleProducts.length) {
        productsRow.innerHTML = '<p style="color:#a1a1aa;">No products found.</p>';
        refreshProductsRowProgress();
        return;
      }
      currentCollectionProducts = visibleProducts;
      productsRow.innerHTML = '';
      visibleProducts.forEach(function (product, index) {
        productsRow.appendChild(buildProductCard(product, index));
      });
      bindProductsRowImageProgressRefresh();
      animateRowReveal(productsRow);
      refreshProductsRowProgress();
      var firstProduct = visibleProducts[0];
      if (firstProduct && firstProduct.handle) {
        setActiveProductCard(firstProduct.handle);
        fetchPDP(firstProduct.handle, firstProduct);
      }
    }

    function fetchProducts(collectionHandle, collectionTitle, silent, shouldAutoScrollToNextStep) {
      shouldAutoScrollToNextStep = shouldAutoScrollToNextStep === true;
      var normalizedCollectionHandle = String(collectionHandle || '').trim();
      var hasWarmProducts = !!normalizedCollectionHandle &&
        collectionProductsReadyState[normalizedCollectionHandle] === 'ready' &&
        collectionProductsCache.hasOwnProperty(normalizedCollectionHandle);

      if (hasWarmProducts) {
        currentCollectionProducts = [];
        if (productsLabel) productsLabel.textContent = collectionTitle || '';
        var requestToken = ++latestProductsRequestToken;
        handleFetchedProducts(collectionProductsCache[normalizedCollectionHandle], requestToken, normalizedCollectionHandle, collectionTitle, silent, shouldAutoScrollToNextStep);
        return;
      }

      clearProducts();
      clearPDP();

      if (productsLabel) productsLabel.textContent = collectionTitle || '';
      if (productsRow) productsRow.innerHTML = loadingHTML();
      refreshProductsRowProgress();
      var requestToken = ++latestProductsRequestToken;

      fetchCollectionProductsCached(normalizedCollectionHandle)
        .then(function (products) {
          if (requestToken !== latestProductsRequestToken || !productsRow) return;
          handleFetchedProducts(products, requestToken, normalizedCollectionHandle, collectionTitle, silent, shouldAutoScrollToNextStep);
        })
        .catch(function () {
          if (requestToken !== latestProductsRequestToken) return;
          currentCollectionProducts = [];
          if (productsRow) {
            productsRow.innerHTML = '<p style="color:#a1a1aa;">Could not load products.</p>';
          }
          refreshProductsRowProgress();
        });
    }

    function deptProductIsExcludedFromTypePicker(product) {
      if (!product) return false;
      var pt = String(product.product_type || product.type || '').toLowerCase().trim();
      if (pt === 'gift card' || pt === 'gift cards') return true;
      if (pt.indexOf('gift card') !== -1) return true;

      var title = String(product.title || '').toLowerCase();
      if (title.indexOf('gift card') !== -1) return true;
      var h = String(product.handle || '').toLowerCase();
      if (/\bgift[\s_-]?card\b/.test(h)) return true;
      if ((/\bgiftcards?\b/).test(h)) return true;
      return false;
    }

    function omitExcludedDeptTypePickerProducts(products) {
      if (!Array.isArray(products)) return [];
      return products.filter(function (p) {
        return !deptProductIsExcludedFromTypePicker(p);
      });
    }

    function handleFetchedProducts(products, requestToken, normalizedCollectionHandle, collectionTitle, silent, shouldAutoScrollToNextStep) {
      if (!productsRow) return;

      products = omitExcludedDeptTypePickerProducts(Array.isArray(products) ? products : []);
      currentCollectionProducts = products;

      var activeGroup = groups.find(function (group) {
        return group.classList.contains('is-active');
      });
      prefetchSiblingCollections(activeGroup, normalizedCollectionHandle);

      if (!products.length) {
        productsRow.innerHTML = '<p style="color:#a1a1aa;">No products found.</p>';
        refreshProductsRowProgress();
        if (shouldAutoScrollToNextStep) {
          scrollToProductsStep();
        }
        return;
      }

      var typeGroups = {};
      products.forEach(function (p) {
        var title = p.title || 'Unknown';
        if (!typeGroups[title]) {
          typeGroups[title] = { products: [] };
        }
        typeGroups[title].products.push(p);
      });

      var typeNames = Object.keys(typeGroups);

      if (typeNames.length >= 2) {
        if (silent) {
          var firstTypeProducts = typeGroups[typeNames[0]].products;
          if (productsLabel) productsLabel.textContent = typeNames[0];
          renderProductCardsForType(firstTypeProducts);
          return;
        }
        renderTypeCards(typeGroups, products, collectionTitle);
        if (shouldAutoScrollToNextStep) {
          scrollToTypeStep();
        }

        if (products.length >= COLLECTION_PRODUCTS_FETCH_LIMIT) {
          var phase2Token = requestToken;
          fetchAllCollectionProducts(normalizedCollectionHandle).then(function (allProducts) {
            if (phase2Token !== latestProductsRequestToken || !typeCardsActive) return;
            allProducts = omitExcludedDeptTypePickerProducts(Array.isArray(allProducts) ? allProducts : []);
            if (!allProducts.length || allProducts.length <= products.length) return;

            var fullTypeGroups = {};
            allProducts.forEach(function (p) {
              var title = p.title || 'Unknown';
              if (!fullTypeGroups[title]) fullTypeGroups[title] = { products: [] };
              fullTypeGroups[title].products.push(p);
            });

            var existingSet = {};
            typeNames.forEach(function (n) { existingSet[n] = true; });
            for (var tName in fullTypeGroups) {
              if (fullTypeGroups.hasOwnProperty(tName)) {
                typeGroups[tName] = fullTypeGroups[tName];
              }
            }

            var newTypeNames = Object.keys(fullTypeGroups).filter(function (n) { return !existingSet[n]; });
            if (!newTypeNames.length) return;

            var activeGroup = groups.find(function (g) { return g.classList.contains('is-active'); });
            if (!activeGroup) return;
            var track = activeGroup.querySelector('.dept__type-cards-track');
            if (!track) return;

            var allButtons = Array.prototype.slice.call(activeGroup.querySelectorAll('[data-type-card]'));

            newTypeNames.forEach(function (typeName) {
              var group = typeGroups[typeName];
              var img = getProductImage(group.products[0]);
              var btnHTML =
                '<button type="button" class="category-card" data-type-card data-type-name="' + escapeHTML(typeName) + '" style="opacity:0;transition:opacity .3s ease;">' +
                  '<span class="category-card__image-wrap">' +
                    (img
                      ? '<img class="category-card__image" src="' + escapeHTML(resizeImage(img, 400)) + '" alt="' + escapeHTML(typeName) + '" loading="lazy" width="400" height="400">'
                      : '<span class="category-card__skeleton category-card__skeleton--image"></span>') +
                  '</span>' +
                  '<span class="category-card__body">' +
                    '<span class="category-card__title">' + escapeHTML(typeName) + '</span>' +
                    '<span class="category-card__colors" data-type-colors="' + escapeHTML(typeName) + '">' +
                      '<span class="category-card__skeleton category-card__skeleton--text"></span>' +
                    '</span>' +
                  '</span>' +
                '</button>';
              track.insertAdjacentHTML('beforeend', btnHTML);
            });

            window.requestAnimationFrame(function () {
              var freshButtons = Array.prototype.slice.call(activeGroup.querySelectorAll('[data-type-card]'));
              freshButtons.forEach(function (btn) {
                btn.style.opacity = '1';
              });

              var newButtons = freshButtons.filter(function (btn) {
                return allButtons.indexOf(btn) === -1;
              });
              newButtons.forEach(function (btn) {
                btn.addEventListener('click', function () {
                  var typeName = btn.dataset.typeName;
                  freshButtons.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
                  if (productsLabel) productsLabel.textContent = typeName;
                  var filtered = typeGroups[typeName] ? typeGroups[typeName].products : [];
                  renderProductCardsForType(filtered);
                });
              });

              allButtons.forEach(function (oldBtn) {
                var clone = oldBtn.cloneNode(true);
                oldBtn.parentNode.replaceChild(clone, oldBtn);
                clone.addEventListener('click', function () {
                  var typeName = clone.dataset.typeName;
                  freshButtons = Array.prototype.slice.call(activeGroup.querySelectorAll('[data-type-card]'));
                  freshButtons.forEach(function (b) { b.classList.toggle('is-active', b === clone); });
                  if (productsLabel) productsLabel.textContent = typeName;
                  var filtered = typeGroups[typeName] ? typeGroups[typeName].products : [];
                  renderProductCardsForType(filtered);
                });
              });
            });

            hydrateTypeCardColors(typeGroups);
          });
        }

        return;
      }

      function renderProductCards(productsList) {
        var visibleProducts = productsLimit > 0 ? productsList.slice(0, productsLimit) : productsList;
        prefetchProductDetails(visibleProducts);
        if (!visibleProducts.length) {
          productsRow.innerHTML = '<p style="color:#a1a1aa;">No products found.</p>';
          refreshProductsRowProgress();
          if (shouldAutoScrollToNextStep) {
            scrollToProductsStep();
          }
          return;
        }

        productsRow.innerHTML = '';
        visibleProducts.forEach(function (product, index) {
          productsRow.appendChild(buildProductCard(product, index));
        });
        bindProductsRowImageProgressRefresh();
        animateRowReveal(productsRow);
        refreshProductsRowProgress();

        var firstProduct = visibleProducts[0];
        if (firstProduct && firstProduct.handle) {
          setActiveProductCard(firstProduct.handle);
          fetchPDP(firstProduct.handle, firstProduct);
        }

        if (shouldAutoScrollToNextStep) {
          scrollToProductsStep();
        }
      }

      if (!dedupColors) {
        renderProductCards(products);
        return;
      }

      renderProductCards(products);
      var allHandles = products.map(function (p) { return p.handle; }).filter(Boolean);
      var initialHandleSignature = allHandles.join('|');

      fetchSiblingMap(allHandles).then(function (siblingMap) {
        if (requestToken !== latestProductsRequestToken || !productsRow) return;
        var seenParents = {};
        var deduplicated = [];

        products.forEach(function (product) {
          var parentHandle = (siblingMap && siblingMap[product.handle]) || product.handle;
          if (seenParents[parentHandle]) return;
          seenParents[parentHandle] = true;
          deduplicated.push(product);
        });

        var dedupedSignature = deduplicated.map(function (p) { return p && p.handle ? p.handle : ''; }).join('|');
        if (dedupedSignature === initialHandleSignature) return;
        renderProductCards(deduplicated);
      }).catch(function () {
        if (requestToken !== latestProductsRequestToken || !productsRow) return;
      });
    }

    function deptIsVariantAvailable(variant) {
      if (!variant) return false;
      if (typeof variant.available === 'undefined') return true;
      return !!variant.available;
    }

    function deptFindFirstAvailableVariant(variants) {
      if (!Array.isArray(variants) || !variants.length) return null;
      return variants.find(function (variant) {
        return deptIsVariantAvailable(variant);
      }) || null;
    }

    function deptFindMatchingVariant(variants, selectedByIndex, requireAvailable) {
      if (!Array.isArray(variants) || !variants.length) return null;

      return variants.find(function (variant) {
        if (!variant) return false;
        if (requireAvailable && !deptIsVariantAvailable(variant)) return false;

        var option1Ok = selectedByIndex[0] === undefined || variant.option1 === selectedByIndex[0];
        var option2Ok = selectedByIndex[1] === undefined || variant.option2 === selectedByIndex[1];
        var option3Ok = selectedByIndex[2] === undefined || variant.option3 === selectedByIndex[2];
        return option1Ok && option2Ok && option3Ok;
      }) || null;
    }

    function setActiveProductCard(handle) {
      if (!productsRow) return;
      var allCards = Array.prototype.slice.call(productsRow.querySelectorAll('.dept__product-card'));
      allCards.forEach(function (c) {
        c.classList.toggle('is-active', c.dataset.productHandle === handle);
      });
    }

    function buildProductCard(product, index) {
      var card = document.createElement('article');
      card.className = 'dept__product-card';
      card.dataset.productHandle = product.handle || '';

      var image = getProductImage(product);
      var displayImage = image
        ? resizeImage(image, 500)
        : (currentCustomProductImage || '');
      var colorVal = getProductColorValue(product);
      var colorTagHTML = '';
      if (colorVal) {
        var hex = getSwatchHex(colorVal);
        colorTagHTML =
          '<div class="dept__product-card-color-tag">' +
            '<span class="dept__product-card-color-dot" style="background:' + hex + ';"></span>' +
            '<span class="dept__product-card-color-text">' + escapeHTML(colorVal) + '</span>' +
          '</div>';
      }

      card.innerHTML =
        '<div class="dept__product-card-media">' +
          (displayImage
            ? '<img src="' + displayImage + '" alt="' + escapeHTML(product.title) + '" loading="lazy">'
            : '') +
          colorTagHTML +
        '</div>' +
        '<div class="dept__product-card-info">' +
          '<div class="dept__product-card-title">' + escapeHTML(product.title) + '</div>' +
        '</div>';

      card.addEventListener('click', function () {
        setActiveProductCard(product.handle);
        fetchPDP(product.handle, product);
        smoothScrollToElement(pdpArea);
      });

      return card;
    }

    function fetchProductVideosPromise(handle) {
      return new Promise(function (resolve) {
        fetchProductVideos(handle, function (videos) {
          resolve(Array.isArray(videos) ? videos : []);
        });
      });
    }

    function injectVideoIntoPDP(normalizedHandle, requestToken) {
      fetchProductVideosPromise(normalizedHandle).then(function (videos) {
        if (requestToken !== latestPdpRequestToken || !pdpArea) return;
        if (!Array.isArray(videos) || !videos.length) return;
        var mainImage = pdpArea.querySelector('.dept__pdp-main-image');
        var thumbRail = pdpArea.querySelector('.dept__pdp-thumb-rail');
        if (!mainImage) return;

        var bestSources = pickBestVideoSources(videos[0].sources || []);
        var poster = videos[0].poster || '';
        var sourceTags = bestSources.map(function (s) {
          return '<source src="' + s.url + '" type="' + (s.type || 'video/mp4') + '">';
        }).join('');
        var videoHTML = '<video class="dept__pdp-media--video" autoplay loop muted playsinline preload="auto"' +
          (poster ? ' poster="' + poster + '"' : '') + '>' + sourceTags + '</video>';
        var videoItem = document.createElement('div');
        videoItem.className = 'dept__pdp-media-item';
        videoItem.setAttribute('data-media-idx', '0');
        videoItem.innerHTML = videoHTML;

        var existingItems = mainImage.querySelectorAll('.dept__pdp-media-item');
        for (var i = 0; i < existingItems.length; i++) {
          var oldIdx = parseInt(existingItems[i].getAttribute('data-media-idx'), 10);
          existingItems[i].setAttribute('data-media-idx', String(oldIdx + 1));
        }
        mainImage.insertBefore(videoItem, mainImage.firstChild);

        var activeItem = mainImage.querySelector('.dept__pdp-media-item.is-active');
        if (activeItem) activeItem.classList.remove('is-active');
        videoItem.classList.add('is-active');

        if (thumbRail) {
          var thumbHTML = '<div class="dept__pdp-thumb dept__pdp-thumb--active dept__pdp-thumb--video" data-media-index="0">' +
            (poster ? '<img src="' + poster + '" alt="" loading="lazy">' : '') + '</div>';
          var existingThumbs = thumbRail.querySelectorAll('.dept__pdp-thumb');
          for (var j = 0; j < existingThumbs.length; j++) {
            existingThumbs[j].classList.remove('dept__pdp-thumb--active');
            var oldThumbIdx = parseInt(existingThumbs[j].getAttribute('data-media-index'), 10);
            existingThumbs[j].setAttribute('data-media-index', String(oldThumbIdx + 1));
          }
          thumbRail.insertAdjacentHTML('afterbegin', thumbHTML);
        }

        var vid = videoItem.querySelector('video');
        if (vid) ensurePDPVideoAutoplay(vid);
      });
    }

    function fetchPDP(handle, collectionProductContext) {
      if (!pdpArea) return;
      var normalizedHandle = String(handle || '').trim();
      if (!normalizedHandle) {
        clearPDP();
        pdpArea.innerHTML = '<p style="color:#a1a1aa;">Could not load product details.</p>';
        return;
      }
      var warmProduct = productJsonCache[normalizedHandle] || null;
      var cachedVideos = Array.isArray(videoCache[normalizedHandle]) ? videoCache[normalizedHandle] : null;

      if (warmProduct) {
        var productData = warmProduct;
        if (activePdpVisibilityHandler) {
          document.removeEventListener('visibilitychange', activePdpVisibilityHandler);
          activePdpVisibilityHandler = null;
        }
        var requestToken = ++latestPdpRequestToken;
        renderPDP(productData, collectionProductContext, cachedVideos || []);
        if (!cachedVideos) {
          injectVideoIntoPDP(normalizedHandle, requestToken);
        }
        return;
      }

      clearPDP();
      pdpArea.innerHTML = loadingPDPHTML();
      var requestToken = ++latestPdpRequestToken;

      fetchProductJsonCached(normalizedHandle)
        .then(function (productData) {
          if (requestToken !== latestPdpRequestToken) return;
          if (!productData && collectionProductContext && String(collectionProductContext.handle || '').trim() === normalizedHandle) {
            productData = collectionProductContext;
          }
          if (!productData) {
            throw new Error('Missing product payload');
          }

          return warmProductHTMLCaches(normalizedHandle).catch(function () {}).then(function () {
            return productData;
          });
        })
        .then(function (productData) {
          if (requestToken !== latestPdpRequestToken || !productData) return;
          var cachedVideos = Array.isArray(videoCache[normalizedHandle]) ? videoCache[normalizedHandle] : null;
          renderPDP(productData, collectionProductContext, cachedVideos || []);

          if (!cachedVideos) {
            injectVideoIntoPDP(normalizedHandle, requestToken);
          }
        })
        .catch(function () {
          if (requestToken !== latestPdpRequestToken) return;
          pdpArea.innerHTML = '<p style="color:#a1a1aa;">Could not load product details.</p>';
        });
    }

    function pickBestVideoSources(sources) {
      if (!sources || !sources.length) return [];
      var dominated = sources.filter(function (s) {
        var t = (s.type || '').toLowerCase();
        return t.indexOf('video/') === 0;
      });
      if (!dominated.length) dominated = sources;
      dominated.sort(function (a, b) { return (a.width || 0) - (b.width || 0); });
      var best = null;
      for (var i = 0; i < dominated.length; i++) {
        if ((dominated[i].width || 0) >= 480) { best = dominated[i]; break; }
      }
      if (!best) best = dominated[dominated.length - 1];
      return [best];
    }


    function deptNormalizeProductType(value) {
      return String(value || '').toLowerCase().replace(/\s+/g, ' ').trim();
    }


    function renderPDP(product, collectionProductContext, videos) {
      if (!pdpArea || !product) {
        return;
      }

      var images = product.images || [];
      var variants = product.variants || [];
      videos = Array.isArray(videos) ? videos : [];

      if (collectionProductContext && Array.isArray(collectionProductContext.variants)) {
        var availMap = {};
        collectionProductContext.variants.forEach(function(cv) {
          if (cv.id) availMap[cv.id] = cv.available;
        });
        variants.forEach(function(v) {
          if (typeof v.available === 'undefined' && availMap.hasOwnProperty(v.id)) {
            v.available = availMap[v.id];
          }
        });
      }

      var firstVariant = deptFindFirstAvailableVariant(variants);
      var productAvailable = product.available === true || (firstVariant !== null);

      var mediaList = [];
      if (videos.length > 0) {
        var rawSources = videos[0].sources || [];
        var bestSources = pickBestVideoSources(rawSources);
        mediaList.push({ type: 'video', poster: videos[0].poster, sources: bestSources });
      }
      images.forEach(function (image) {
        mediaList.push({ type: 'image', src: image });
      });

      var thumbsHTML = mediaList.map(function (media, index) {
        var activeClass = index === 0 ? ' dept__pdp-thumb--active' : '';
        var videoClass = media.type === 'video' ? ' dept__pdp-thumb--video' : '';
        var thumbSrc = media.type === 'video'
          ? (media.poster || '')
          : resizeImage(media.src, 120);
        return (
          '<div class="dept__pdp-thumb' + activeClass + videoClass + '" data-media-index="' + index + '">' +
            (thumbSrc ? '<img src="' + thumbSrc + '" alt="" loading="lazy">' : '') +
          '</div>'
        );
      }).join('');

      var allMediaHTML = mediaList.map(function (media, idx) {
        var activeClass = idx === 0 ? ' is-active' : '';
        var inner = '';
        if (media.type === 'video') {
          var sourceTags = media.sources.map(function (s) {
            return '<source src="' + s.url + '" type="' + (s.type || 'video/mp4') + '">';
          }).join('');
          inner = '<video class="dept__pdp-media--video" ' + (idx === 0 ? 'autoplay ' : '') + 'loop muted playsinline preload="auto"' +
            (media.poster ? ' poster="' + media.poster + '"' : '') +
            '>' + sourceTags + '</video>';
        } else {
          inner = '<img class="dept__pdp-media--image" src="' + resizeImage(media.src, 900) + '" alt="' + escapeHTML(product.title) + '" loading="eager">';
        }
        return '<div class="dept__pdp-media-item' + activeClass + '" data-media-idx="' + idx + '">' + inner + '</div>';
      }).join('');

      var pdpColorVal = getProductColorValue(product);
      if (!pdpColorVal && product.handle) {
        var pdpColorToken = getColorTokenFromHandle(product.handle);
        pdpColorVal = formatColorTokenLabel(pdpColorToken);
      }
      var pdpColorTagHTML = pdpColorVal
        ? '<div class="dept__pdp-color-badge" data-dept-pdp-color-tag>' + escapeHTML(pdpColorVal) + '</div>'
        : '';

      var price = formatMoney(firstVariant ? firstVariant.price : 0);
      var comparePriceHTML = '';
      if (firstVariant && firstVariant.compare_at_price && firstVariant.compare_at_price > firstVariant.price) {
        comparePriceHTML = '<span class="dept__pdp-compare">' + formatMoney(firstVariant.compare_at_price) + '</span>';
      }

      var options = product.options || [];
      var selectedByIndex = {};
      var initialSwatchHTML = buildCrossProductColorSwitcherHTML(product, collectionProductContext);
      var colorSwitcherHTML = '<div data-pdp-color-switcher>' + (initialSwatchHTML || colorSwatchSkeletonHTML()) + '</div>';
      var optionsHTML = '';

      if (firstVariant && firstVariant.option1 !== undefined) selectedByIndex[0] = firstVariant.option1;
      if (firstVariant && firstVariant.option2 !== undefined) selectedByIndex[1] = firstVariant.option2;
      if (firstVariant && firstVariant.option3 !== undefined) selectedByIndex[2] = firstVariant.option3;

      options.forEach(function (option, optionIndex) {
        if (
          option.name &&
          option.name.toLowerCase() === 'title' &&
          option.values &&
          option.values.length === 1 &&
          option.values[0] === 'Default Title'
        ) {
          return;
        }

        if (selectedByIndex[optionIndex] === undefined && option.values && option.values.length) {
          selectedByIndex[optionIndex] = option.values[0];
        }

        var optionName = option.name || 'Option';
        var isColorOption = isColorOptionName(optionName, colorOptionNames);
        var isLengthOption = optionName.toLowerCase().trim() === 'length';
        var rowClasses = 'dept__pdp-variants';
        if (isColorOption) {
          rowClasses += ' dept__pdp-variants--swatches';
        } else if (isLengthOption) {
          rowClasses += ' dept__pdp-variants--length';
        }

        optionsHTML +=
          '<div class="dept__pdp-option-section">' +
            '<span class="dept__pdp-option-label">' + escapeHTML(optionName) + '</span>' +
            '<div class="' + rowClasses + '" data-option-index="' + optionIndex + '" data-option-name="' + escapeHTML(optionName) + '">';

        (option.values || []).forEach(function (value, valueIndex) {
          var isInitiallyActive = selectedByIndex[optionIndex] === value;
          var escapedValue = escapeHTML(value);
          var activeClasses = isInitiallyActive ? ' dept__pdp-option-btn--active' : '';

          if (isColorOption) {
            var swatchHex = getSwatchHex(value);
            optionsHTML +=
              '<button type="button" class="dept__pdp-option-btn dept__pdp-swatch-btn' + activeClasses + (isInitiallyActive ? ' dept__pdp-swatch-btn--active' : '') + '"' +
                ' data-option-index="' + optionIndex + '"' +
                ' data-option-value="' + escapedValue + '"' +
                ' title="' + escapedValue + '"' +
                ' aria-label="' + escapeHTML(optionName + ': ' + value) + '">' +
                '<span class="dept__pdp-swatch-dot" style="--dept-pdp-swatch-color:' + swatchHex + ';"></span>' +
                '<span class="dept__pdp-swatch-label">' + escapedValue + '</span>' +
              '</button>';
          } else if (isLengthOption) {
            var lengthSubtext = '';
            var vLow = value.toLowerCase().trim();
            if (vLow === 'petite') lengthSubtext = '29\u2033 \u2013 Up to 5\u20195\u2033';
            else if (vLow === 'regular') lengthSubtext = '31\u2033 \u2013 5\u20196\u2033 to 5\u20198\u2033';
            else if (vLow === 'tall') lengthSubtext = '33\u2033 \u2013 5\u20199\u2033 and above';
            optionsHTML +=
              '<button type="button" class="dept__pdp-option-btn dept__pdp-variant-btn dept__pdp-variant-btn--length' + activeClasses + (isInitiallyActive ? ' dept__pdp-variant-btn--active' : '') + '"' +
                ' data-option-index="' + optionIndex + '"' +
                ' data-option-value="' + escapedValue + '">' +
                '<span class="dept__pdp-variant-main">' + escapedValue + '</span>' +
                (lengthSubtext ? '<small class="dept__pdp-variant-sub">' + lengthSubtext + '</small>' : '') +
              '</button>';
          } else {
            optionsHTML +=
              '<button type="button" class="dept__pdp-option-btn dept__pdp-variant-btn' + activeClasses + (isInitiallyActive ? ' dept__pdp-variant-btn--active' : '') + '"' +
                ' data-option-index="' + optionIndex + '"' +
                ' data-option-value="' + escapedValue + '">' +
                escapedValue +
              '</button>';
          }
        });

        optionsHTML += '</div></div>';
      });

      var accordionChevron = '<span class="dept__pdp-accordion__icon"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg></span>';

      function buildAccordion(title, content) {
        return '<details class="dept__pdp-accordion">' +
          '<summary class="dept__pdp-accordion__summary">' +
            '<span class="dept__pdp-accordion__title">' + escapeHTML(title) + '</span>' +
            accordionChevron +
          '</summary>' +
          '<div class="dept__pdp-accordion__content-wrapper">' +
            '<div class="dept__pdp-accordion__content">' +
              '<div class="dept__pdp-accordion__content-inner">' + content + '</div>' +
            '</div>' +
          '</div>' +
        '</details>';
      }

      var descriptionHTML = product.body_html ? buildAccordion('Product Details', product.body_html) : '';
      var productHandle = String(product.handle || '').trim();
      var accordionData = productHandle && accordionContentCache.hasOwnProperty(productHandle)
        ? accordionContentCache[productHandle]
        : null;
      var fabricAndCareContent = '';
      if (accordionData && typeof accordionData.fabric === 'string') {
        fabricAndCareContent = accordionData.fabric.trim();
      }
      if (!fabricAndCareContent && typeof product.fabric_html === 'string') {
        fabricAndCareContent = product.fabric_html.trim();
      }
      if (fabricAndCareContent) {
        descriptionHTML += buildAccordion('Fabric & Care', fabricAndCareContent);
      }
      descriptionHTML += buildAccordion('Care Tips', '<p>Turn garment inside out before wash to preserve finish.</p><p>Avoid bleach and high heat drying. Hang immediately after cycle for best drape.</p>');
      descriptionHTML += buildAccordion('Shipping & Returns', '<p>Free shipping on orders over $65. Returns accepted within 30 days of delivery.</p>');

      var atcDisabled = !productAvailable || !deptIsVariantAvailable(firstVariant);
      var atcButtonLabel = atcDisabled ? 'Sold Out' : 'Add to Cart';

      var pdpContentHTML =
        '<div class="dept__pdp-mount" data-pdp-mount>' +
        '<div class="dept__loading-skeleton pdp dept__pdp-skeleton-layer">' +
             '<div class="dept__skeleton-gallery">' +
               '<div class="dept__skeleton-thumbs">' +
                 '<div class="dept__skeleton-thumb"></div>' +
                 '<div class="dept__skeleton-thumb"></div>' +
                 '<div class="dept__skeleton-thumb"></div>' +
                 '<div class="dept__skeleton-thumb"></div>' +
               '</div>' +
               '<div class="dept__skeleton-main-img"></div>' +
             '</div>' +
             '<div class="dept__skeleton-info">' +
               '<div class="dept__skeleton-title"></div>' +
               '<div class="dept__skeleton-rating"></div>' +
               '<div class="dept__skeleton-price"></div>' +
               '<div class="dept__skeleton-swatches"></div>' +
               '<div class="dept__skeleton-options"></div>' +
               '<div class="dept__skeleton-options dept__skeleton-options--short"></div>' +
               '<div class="dept__skeleton-size-guide"></div>' +
               '<div class="dept__skeleton-btn"></div>' +
               '<div class="dept__skeleton-badges"></div>' +
               '<div class="dept__skeleton-accordion"></div>' +
               '<div class="dept__skeleton-accordion"></div>' +
               '<div class="dept__skeleton-accordion"></div>' +
               '<div class="dept__skeleton-accordion"></div>' +
             '</div>' +
             '</div>' +
        '<div class="dept__pdp-inner dept__pdp-content-layer dept__pdp-inner--pending" data-pdp-content>' +
          '<div class="dept__pdp-gallery">' +
            '<div class="dept__pdp-thumbs">' + thumbsHTML + '</div>' +
            '<div class="dept__pdp-main-image" data-main-image>' + allMediaHTML + pdpColorTagHTML + '</div>' +
          '</div>' +
          '<div class="dept__pdp-info">' +
            buildSoldBadgeHTML(product) +
            '<h2 class="dept__pdp-title"><a href="/products/' + encodeURIComponent(product.handle) + '" class="dept__pdp-title-link">' + escapeHTML(product.title) + '</a></h2>' +
            buildRatingHTML() +
            '<div class="dept__pdp-price">' +
              '<span data-pdp-price>' + price + '</span>' +
              '<span data-pdp-compare>' + comparePriceHTML + '</span>' +
            '</div>' +
            '<div class="dept__pdp-checkout-offer" style="color:#d60000;font-size:13px;font-weight:600;margin:2px 0 8px;letter-spacing:.02em;">10% OFF ON CHECKOUT</div>' +
            colorSwitcherHTML +
            optionsHTML +
            '<button type="button" class="dept__pdp-size-chart-btn" data-dept-size-chart-open>' +
              'Size Chart' +
            '</button>' +
            '<button type="button" class="dept__pdp-atc" data-variant-id="' + ((firstVariant && firstVariant.id) || '') + '"' + (atcDisabled ? ' disabled' : '') + '>' + atcButtonLabel + '</button>' +
            '<div class="dept__pdp-badges">' +
              '<div class="dept__pdp-badge">' +
                '<svg class="dept__pdp-badge-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/><text x="12" y="15" text-anchor="middle" font-size="8" font-weight="700" fill="currentColor" stroke="none">30</text></svg>' +
                '<div class="dept__pdp-badge-text"><span class="dept__pdp-badge-title">30-Day Guarantee</span><span class="dept__pdp-badge-sub">Easy Returns &amp; Exchanges</span></div>' +
              '</div>' +
            '</div>' +
            descriptionHTML +
          '</div>' +
        '</div>' +
        '</div>';

      pdpArea.innerHTML = pdpContentHTML;
      pdpArea.dataset.currentProductHandle = product.handle || '';
      bindPDPInteractions(product, mediaList, variants, selectedByIndex);
      var skeleton = pdpArea.querySelector('.dept__pdp-skeleton-layer');
      if (skeleton && skeleton.parentNode) skeleton.remove();
      var content = pdpArea.querySelector('[data-pdp-content]');
      if (content) {
        content.classList.remove('dept__pdp-inner--pending');
        content.classList.add('is-ready');
      }

      hydrateCrossProductColorSwitcher(product);
      hydrateRating(product);
    }

    function ensurePDPVideoAutoplay(videoEl) {
      if (!videoEl) return;
      videoEl.muted = true;
      videoEl.defaultMuted = true;
      videoEl.loop = true;
      videoEl.autoplay = true;
      videoEl.playsInline = true;
      videoEl.preload = 'auto';
      videoEl.controls = false;
      videoEl.removeAttribute('controls');
      videoEl.setAttribute('muted', '');
      videoEl.setAttribute('loop', '');
      videoEl.setAttribute('autoplay', '');
      videoEl.setAttribute('playsinline', '');

      var playVideo = function () {
        if (!videoEl || !videoEl.isConnected) return;
        var playPromise = videoEl.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {});
        }
      };

      playVideo();

      if (videoEl.dataset.deptAutoplayBound !== 'true') {
        videoEl.dataset.deptAutoplayBound = 'true';
        videoEl.addEventListener('loadedmetadata', playVideo, { passive: true });
        videoEl.addEventListener('canplay', playVideo, { passive: true });
      }
    }

    function bindPDPInteractions(product, mediaList, variants, selectedByIndex) {
      var thumbs = Array.prototype.slice.call(pdpArea.querySelectorAll('.dept__pdp-thumb'));
      var mainImage = pdpArea.querySelector('[data-main-image]');
      var thumbsRail = pdpArea.querySelector('.dept__pdp-thumbs');

      if (syncPDPThumbRailOnResize) {
        window.removeEventListener('resize', syncPDPThumbRailOnResize);
        syncPDPThumbRailOnResize = null;
      }

      function syncPDPThumbRailHeight() {
        if (!thumbsRail || !mainImage) return;

        var mainImageRect = mainImage.getBoundingClientRect();
        if (!mainImageRect || !mainImageRect.height) return;

        thumbsRail.style.setProperty('--dept-pdp-thumbs-max-height', Math.round(mainImageRect.height) + 'px');
      }

      function scrollThumbIntoView(thumb) {
        if (!thumb) return;

        try {
          thumb.scrollIntoView({
            block: 'nearest',
            inline: 'nearest',
            behavior: 'smooth'
          });
        } catch (error) {
          thumb.scrollIntoView();
        }
      }

      function switchMedia(newIndex) {
        if (!mainImage) return;
        var currentItem = mainImage.querySelector('.dept__pdp-media-item.is-active');
        var nextItem = mainImage.querySelector('[data-media-idx="' + newIndex + '"]');
        if (!nextItem || nextItem === currentItem) return;

        var currentHeight = mainImage.offsetHeight;
        mainImage.style.height = currentHeight + 'px';

        if (currentItem) {
          var oldVid = currentItem.querySelector('video');
          if (oldVid) oldVid.pause();
          currentItem.classList.remove('is-active');
        }

        nextItem.classList.add('is-active');
        var newVid = nextItem.querySelector('video');
        if (newVid) ensurePDPVideoAutoplay(newVid);

        window.requestAnimationFrame(function () {
          var newHeight = nextItem.offsetHeight || mainImage.scrollHeight;
          mainImage.style.height = newHeight + 'px';
        });

        syncPDPThumbRailHeight();
      }

      function onMainImageTransitionEnd(e) {
        if (e.propertyName === 'height' && e.target === mainImage) {
          mainImage.style.height = '';
          syncPDPThumbRailHeight();
        }
      }
      mainImage.addEventListener('transitionend', onMainImageTransitionEnd);

      var heightClearFallback = null;
      function scheduleHeightClear() {
        if (heightClearFallback) clearTimeout(heightClearFallback);
        heightClearFallback = setTimeout(function () {
          if (mainImage && mainImage.style.height) {
            mainImage.style.height = '';
            syncPDPThumbRailHeight();
          }
        }, 500);
      }

      syncPDPThumbRailHeight();
      syncPDPThumbRailOnResize = function () {
        mainImage.style.height = '';
        syncPDPThumbRailHeight();
      };
      window.addEventListener('resize', syncPDPThumbRailOnResize);

      var activeItem = mainImage ? mainImage.querySelector('.dept__pdp-media-item.is-active') : null;
      if (activeItem) {
        var initImg = activeItem.querySelector('img');
        var initVid = activeItem.querySelector('video');
        if (initImg && !initImg.complete) {
          initImg.addEventListener('load', syncPDPThumbRailHeight, { once: true });
        } else if (initVid) {
          ensurePDPVideoAutoplay(initVid);
          initVid.addEventListener('loadeddata', syncPDPThumbRailHeight, { once: true });
        }
      }

      if (activePdpVisibilityHandler) {
        document.removeEventListener('visibilitychange', activePdpVisibilityHandler);
      }
      activePdpVisibilityHandler = function () {
        if (document.visibilityState !== 'visible') return;
        var activeVideo = mainImage ? mainImage.querySelector('.dept__pdp-media-item.is-active video') : null;
        ensurePDPVideoAutoplay(activeVideo);
      };
      document.addEventListener('visibilitychange', activePdpVisibilityHandler);

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var index = parseInt(thumb.dataset.mediaIndex, 10);
          thumbs.forEach(function (item) { item.classList.remove('dept__pdp-thumb--active'); });
          thumb.classList.add('dept__pdp-thumb--active');
          scrollThumbIntoView(thumb);
          switchMedia(index);
          scheduleHeightClear();
        });
      });

      var colorSwitchButtons = Array.prototype.slice.call(pdpArea.querySelectorAll('.dept__pdp-color-switch-btn'));
      colorSwitchButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          var targetHandle = button.dataset.productHandle || '';
          if (!targetHandle || targetHandle === product.handle) return;
          fetchPDP(targetHandle);
        });
      });

      var optionButtons = Array.prototype.slice.call(
        pdpArea.querySelectorAll('.dept__pdp-option-btn:not(.dept__pdp-color-switch-btn)')
      );
      optionButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          if (button.disabled) return;

          var optionIndex = parseInt(button.dataset.optionIndex, 10);
          var optionValue = button.dataset.optionValue || '';

          selectedByIndex[optionIndex] = optionValue;

          var row = button.closest('.dept__pdp-variants');
          if (row) {
            Array.prototype.slice.call(row.querySelectorAll('.dept__pdp-option-btn')).forEach(function (rowButton) {
              var isActive = rowButton === button;
              rowButton.classList.toggle('dept__pdp-option-btn--active', isActive);
              if (rowButton.classList.contains('dept__pdp-variant-btn')) {
                rowButton.classList.toggle('dept__pdp-variant-btn--active', isActive);
              }
              if (rowButton.classList.contains('dept__pdp-swatch-btn')) {
                rowButton.classList.toggle('dept__pdp-swatch-btn--active', isActive);
              }
            });
          }

          updatePDPOptionAvailability(variants, selectedByIndex);
          syncVariantState(variants, selectedByIndex);
        });
      });

      updatePDPOptionAvailability(variants, selectedByIndex);
      syncVariantState(variants, selectedByIndex);

      var atcButton = pdpArea.querySelector('.dept__pdp-atc');
      if (atcButton) {
        atcButton.addEventListener('click', function () {
          var variantId = parseInt(atcButton.dataset.variantId, 10);
          if (!variantId) return;

          atcButton.disabled = true;
          atcButton.textContent = 'Adding...';

          (window.CartAPI ? window.CartAPI.addItem(variantId, 1) : fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 })
          }).then(function (r) { return r.json(); }))
            .then(function () {
              atcButton.textContent = 'Added!';
              setTimeout(function () {
                syncVariantState(variants, selectedByIndex);
              }, 1400);
            })
            .catch(function () {
              syncVariantState(variants, selectedByIndex);
            });
        });
      }

      var sizeChartBtn = pdpArea.querySelector('[data-dept-size-chart-open]');
      if (sizeChartBtn) {
        function buildSizeChartIframeHTML() {
          var productType = product.product_type || product.type || '';
          if (!productType) return null;
          return DEPT_SIZE_CHART_FULL_HTML.replace('__PRODUCT_TYPE__', productType.replace(/'/g, "\\'"));
        }

        var sizeChartIframeOverlay = null;

        function openSizeChartIframe() {
          var html = buildSizeChartIframeHTML();
          if (!html) return;

          sizeChartIframeOverlay = document.createElement('div');
          sizeChartIframeOverlay.style.cssText = 'position:fixed;inset:0;z-index:2147483001;background:rgba(0,0,0,0.5);display:flex;align-items:flex-start;justify-content:center;padding-top:4vh;';

          var modal = document.createElement('div');
          modal.style.cssText = 'background:#fff;width:96vw;max-width:1100px;height:92vh;max-height:92vh;border-radius:12px;overflow:hidden;box-shadow:0 25px 50px -12px rgba(0,0,0,0.25);';

          var iframe = document.createElement('iframe');
          iframe.style.cssText = 'width:100%;height:100%;border:none;display:block;';
          iframe.setAttribute('srcdoc', html);

          modal.appendChild(iframe);
          sizeChartIframeOverlay.appendChild(modal);
          document.body.appendChild(sizeChartIframeOverlay);
          document.body.style.overflow = 'hidden';

          sizeChartIframeOverlay.addEventListener('click', function (e) {
            if (e.target === sizeChartIframeOverlay) closeSizeChartIframe();
          });
        }

        function closeSizeChartIframe() {
          if (sizeChartIframeOverlay && sizeChartIframeOverlay.parentNode) {
            sizeChartIframeOverlay.parentNode.removeChild(sizeChartIframeOverlay);
          }
          sizeChartIframeOverlay = null;
          document.body.style.overflow = '';
        }

        window.addEventListener('message', function (e) {
          if (e.data === 'dept-size-chart-close') closeSizeChartIframe();
        });

        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && sizeChartIframeOverlay) closeSizeChartIframe();
        });

        sizeChartBtn.addEventListener('click', openSizeChartIframe);
      }
    }

    function syncVariantState(variants, selectedByIndex) {
      if (!variants.length) return;

      var matched = deptFindMatchingVariant(variants, selectedByIndex, true)
        || deptFindMatchingVariant(variants, selectedByIndex, false)
        || null;
      var fallbackVariant = deptFindFirstAvailableVariant(variants);
      var displayVariant = matched || fallbackVariant;

      var priceNode = pdpArea.querySelector('[data-pdp-price]');
      var compareNode = pdpArea.querySelector('[data-pdp-compare]');
      var atcButton = pdpArea.querySelector('.dept__pdp-atc');

      if (priceNode) priceNode.textContent = formatMoney(displayVariant ? displayVariant.price : 0);
      if (compareNode) {
        if (displayVariant && displayVariant.compare_at_price && displayVariant.compare_at_price > displayVariant.price) {
          compareNode.innerHTML = '<span class="dept__pdp-compare">' + formatMoney(displayVariant.compare_at_price) + '</span>';
        } else {
          compareNode.innerHTML = '';
        }
      }

      if (atcButton) {
        var variantSellable = deptIsVariantAvailable(matched);
        atcButton.dataset.variantId = matched && matched.id ? matched.id : '';
        atcButton.disabled = !variantSellable;
        atcButton.textContent = variantSellable ? 'Add to Cart' : 'Sold Out';
      }

      var colorTag = pdpArea.querySelector('[data-dept-pdp-color-tag]');
      if (colorTag) {
        var currentHandle = pdpArea.dataset.currentProductHandle || '';
        var newColor = '';
        if (displayVariant) {
          newColor = getProductColorValue({ options: [], variants: [displayVariant] });
        }
        if (!newColor && currentHandle) {
          newColor = formatColorTokenLabel(getColorTokenFromHandle(currentHandle));
        }
        if (newColor) {
          colorTag.textContent = newColor;
          colorTag.style.display = '';
        }
      }
    }

    function updatePDPOptionAvailability(variants, selectedByIndex) {
      if (!pdpArea || !variants || !variants.length) return;

      var optionRows = Array.prototype.slice.call(
        pdpArea.querySelectorAll('.dept__pdp-variants[data-option-index]')
      );

      optionRows.forEach(function (row) {
        var optionIndex = parseInt(row.dataset.optionIndex, 10);
        if (isNaN(optionIndex)) return;

        var rowButtons = Array.prototype.slice.call(
          row.querySelectorAll('.dept__pdp-option-btn')
        );

        rowButtons.forEach(function (button) {
          var optionValue = button.dataset.optionValue || '';
          var nextSelection = {
            0: selectedByIndex[0],
            1: selectedByIndex[1],
            2: selectedByIndex[2]
          };
          nextSelection[optionIndex] = optionValue;

          var hasMatchingVariant = false;
          var hasAvailableVariant = false;

          variants.forEach(function (variant) {
            var option1Ok = nextSelection[0] === undefined || variant.option1 === nextSelection[0];
            var option2Ok = nextSelection[1] === undefined || variant.option2 === nextSelection[1];
            var option3Ok = nextSelection[2] === undefined || variant.option3 === nextSelection[2];

            if (option1Ok && option2Ok && option3Ok) {
              hasMatchingVariant = true;
              if (deptIsVariantAvailable(variant)) {
                hasAvailableVariant = true;
              }
            }
          });

          var shouldDisable = !hasMatchingVariant || !hasAvailableVariant;
          button.disabled = shouldDisable;
          button.classList.toggle('is-unavailable', shouldDisable);
        });
      });
    }

    function hydrateInlineDiscoveryCaches() {
      var ratingScript = section.querySelector('[data-dept-ratings]');
      if (ratingScript) {
        try {
          var map = JSON.parse(ratingScript.textContent);
          for (var h in map) {
            if (map.hasOwnProperty(h)) ratingCache[h] = map[h];
          }
        } catch (e) {}
      }
      var videoScript = section.querySelector('[data-dept-videos]');
      if (videoScript) {
        try {
          var vmap = JSON.parse(videoScript.textContent);
          for (var h in vmap) {
            if (vmap.hasOwnProperty(h) && !videoCache[h]) {
              var entry = vmap[h];
              var sources = Array.isArray(entry.sources) ? entry.sources : [];
              var mappedSources = [];
              for (var i = 0; i < sources.length; i++) {
                var s = sources[i];
                if (s.url) mappedSources.push({ url: s.url, type: s.type || '', width: s.width || 0, height: s.height || 0 });
              }
              if (mappedSources.length) {
                videoCache[h] = [{ poster: entry.poster || '', sources: mappedSources }];
              }
            }
          }
        } catch (e) {}
      }

      var productsScript = section.querySelector('[data-dept-products]');
      if (productsScript) {
        try {
          var pmap = JSON.parse(productsScript.textContent);
          for (var collHandle in pmap) {
            if (!pmap.hasOwnProperty(collHandle)) continue;
            var arr = pmap[collHandle];
            if (!Array.isArray(arr)) continue;
            if (!collectionProductsCache.hasOwnProperty(collHandle)) {
              collectionProductsCache[collHandle] = arr;
              collectionProductsReadyState[collHandle] = 'ready';
            }
            for (var pi = 0; pi < arr.length; pi++) {
              var prod = arr[pi];
              if (prod && prod.handle && !productJsonCache.hasOwnProperty(prod.handle)) {
                productJsonCache[prod.handle] = prod;
              }
            }
          }
        } catch (e) {}
      }
    }

    function fetchProductHTML(handle) {
      if (htmlFetchCache[handle]) return htmlFetchCache[handle];
      htmlFetchCache[handle] = fetch('/products/' + encodeURIComponent(handle), { headers: { 'Accept': 'text/html' } })
        .then(function (r) { return r.text(); })
        .catch(function () { return ''; });
      return htmlFetchCache[handle];
    }

    function parseVideosFromHTML(html) {
      if (!html) return [];
      var videos = [];
      try {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var videoEls = doc.querySelectorAll('video');
        for (var i = 0; i < videoEls.length; i++) {
          var vid = videoEls[i];
          var sources = [];
          var sourceEls = vid.querySelectorAll('source');
          for (var j = 0; j < sourceEls.length; j++) {
            var src = sourceEls[j].getAttribute('src') || '';
            var type = sourceEls[j].getAttribute('type') || '';
            if (src) sources.push({ url: src, type: type });
          }
          if (!sources.length) continue;
          var poster = vid.getAttribute('poster') || '';
          if (!poster) {
            var previewImg = vid.closest('[data-media-id]');
            if (previewImg) {
              var img = previewImg.querySelector('img');
              if (img) poster = img.getAttribute('src') || '';
            }
          }
          videos.push({ poster: poster, sources: sources });
        }
      } catch (e) {}
      return videos;
    }

    function fetchProductVideos(handle, callback) {
      if (videoCache[handle]) {
        callback(videoCache[handle]);
        return;
      }
      fetchProductHTML(handle).then(function (html) {
        var videos = parseVideosFromHTML(html);
        videoCache[handle] = videos;
        callback(videos);
      }).catch(function () {
        videoCache[handle] = [];
        callback([]);
      });
    }

    function buildStarsHTML(ratingValue, productId) {
      var starColor = '#facc15';
      var emptyColor = '#d1d5db';
      var starSize = 14;
      var html = '';
      for (var i = 1; i <= 5; i++) {
        var fill = 0;
        if (ratingValue >= i) fill = 100;
        else if (ratingValue > i - 1) fill = Math.round((ratingValue - (i - 1)) * 100);

        if (fill === 100) {
          html += '<svg xmlns="http://www.w3.org/2000/svg" width="' + starSize + '" height="' + starSize + '" viewBox="0 0 24 24" fill="' + starColor + '" stroke="' + starColor + '" stroke-width="1.5"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>';
        } else if (fill === 0) {
          html += '<svg xmlns="http://www.w3.org/2000/svg" width="' + starSize + '" height="' + starSize + '" viewBox="0 0 24 24" fill="' + emptyColor + '" stroke="' + emptyColor + '" stroke-width="1.5"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>';
        } else {
          var gid = 'dept-star-' + (productId || 0) + '-' + i;
          html += '<svg xmlns="http://www.w3.org/2000/svg" width="' + starSize + '" height="' + starSize + '" viewBox="0 0 24 24" stroke-width="1.5"><defs><linearGradient id="' + gid + '"><stop offset="' + fill + '%" stop-color="' + starColor + '"/><stop offset="' + fill + '%" stop-color="' + emptyColor + '"/></linearGradient></defs><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" fill="url(#' + gid + ')" stroke="url(#' + gid + ')"/></svg>';
        }
      }
      return html;
    }

    function buildSoldBadgeHTML(product) {
      var pid = product.id || 0;
      var d = new Date();
      var dateNum = parseInt('' + d.getUTCFullYear() + ('0' + (d.getUTCMonth() + 1)).slice(-2) + ('0' + d.getUTCDate()).slice(-2), 10);
      var pidLow = pid % 1000000;
      var seedA = (pidLow * 31417) % 1000003;
      var seedB = ((dateNum % 1000000) * 7919) % 1000003;
      var combined = (seedA + seedB) % 1000003;
      var minC = 50, maxC = 300;
      var count = (combined % (maxC - minC + 1)) + minC;
      return '<div class="dept__pdp-sold-badge">' +
        '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z"/></svg>' +
        '<span class="dept__pdp-sold-badge-text">' + count + '+ sold</span>' +
        '<span class="dept__pdp-sold-badge-sep">&middot;</span>' +
        '<span class="dept__pdp-sold-badge-time">in the last 24 hours</span>' +
      '</div>';
    }

    function buildRatingHTML() {
      return '<div class="dept__pdp-rating" data-pdp-rating></div>';
    }

    function hydrateRating(product, callback) {
      var done = function () { if (callback) { callback(); callback = null; } };
      if (!pdpArea || !product || !product.handle) { done(); return; }
      var ratingEl = pdpArea.querySelector('[data-pdp-rating]');
      if (!ratingEl) { done(); return; }

      var handle = product.handle;
      if (ratingCache[handle]) {
        renderRatingEl(ratingEl, ratingCache[handle], product.id);
        done();
        return;
      }

      fetchProductHTML(handle)
        .then(function (html) {
          var data = parseRatingFromProductHTML(html);
          ratingCache[handle] = data;
          if (!videoCache[handle]) {
            videoCache[handle] = parseVideosFromHTML(html);
          }
          var activeHandle = String(pdpArea.dataset.currentProductHandle || '').trim();
          if (activeHandle === handle) {
            renderRatingEl(ratingEl, data, product.id);
          }
          done();
        })
        .catch(function () {
          ratingEl.style.display = 'none';
          done();
        });
    }

    function renderRatingEl(el, data, productId) {
      if (!data.count && !data.rating) {
        el.style.display = 'none';
        return;
      }
      var reviewsText = data.count === 1 ? 'review' : 'reviews';
      el.innerHTML =
        '<span class="dept__pdp-rating-stars">' + buildStarsHTML(data.rating, productId) + '</span>' +
        '<span class="dept__pdp-rating-text">' + data.rating.toFixed(1) + ' (' + data.count + ' ' + reviewsText + ')</span>';
      el.style.display = '';
    }

    function buildCrossProductColorSwitcherHTML(product, collectionProductContext) {
      var siblingColors = collectSiblingColorProducts(product, collectionProductContext);
      if (siblingColors.length <= 1) return '';

      var activeColor = '';
      var buttonsHTML = siblingColors.map(function (sibling) {
        var isActive = sibling.handle === product.handle;
        var buttonClasses = 'dept__pdp-option-btn dept__pdp-swatch-btn dept__pdp-color-switch-btn';
        if (isActive) {
          buttonClasses += ' dept__pdp-option-btn--active dept__pdp-swatch-btn--active';
          activeColor = sibling.label || formatColorTokenLabel(sibling.token);
        }

        var label = sibling.label || formatColorTokenLabel(sibling.token);
        return (
          '<button type="button" class="' + buttonClasses + '"' +
            ' data-product-handle="' + escapeHTML(sibling.handle) + '"' +
            ' title="' + escapeHTML(label) + '"' +
            ' aria-label="' + escapeHTML('Color: ' + label) + '"' +
            (isActive ? ' aria-current="true"' : '') + '>' +
            '<span class="dept__pdp-swatch-dot" style="--dept-pdp-swatch-color:' + sibling.hex + ';"></span>' +
          '</button>'
        );
      }).join('');

      return (
        '<div class="dept__pdp-color-section">' +
          '<span class="dept__pdp-color-label">COLOR: <strong>' + escapeHTML(activeColor) + '</strong></span>' +
          '<div class="dept__pdp-variants dept__pdp-variants--swatches dept__pdp-color-switcher">' +
            buttonsHTML +
          '</div>' +
        '</div>'
      );
    }

    function collectSiblingColorProducts(product, collectionProductContext) {
      if (!product) return [];

      var title = product.title || (collectionProductContext && collectionProductContext.title) || '';
      var siblings = [];
      var seenHandles = {};

      function pushCandidate(candidate) {
        if (!candidate || !candidate.handle || seenHandles[candidate.handle]) return;
        if (title && candidate.title && candidate.title !== title) return;
        seenHandles[candidate.handle] = true;
        siblings.push(candidate);
      }

      (currentCollectionProducts || []).forEach(pushCandidate);
      pushCandidate(collectionProductContext);
      if (product.handle) {
        pushCandidate({
          handle: product.handle,
          title: product.title,
          options: product.options,
          variants: product.variants
        });
      }

      return siblings.map(function (candidate) {
        var colorValue = getProductColorValue(candidate);
        var token = normalizeToken(colorValue) || getColorTokenFromHandle(candidate.handle);

        return {
          handle: candidate.handle,
          token: token,
          label: colorValue || formatColorTokenLabel(token),
          hex: getSwatchHex(colorValue || token)
        };
      }).filter(function (item) {
        return !!item.token;
      });
    }

    function getProductColorValue(productLike) {
      if (!productLike || !productLike.options || !productLike.options.length) return '';

      var colorOptionIndex = -1;
      productLike.options.forEach(function (option, index) {
        var optionName = typeof option === 'string' ? option : option && option.name;
        if (colorOptionIndex === -1 && isColorOptionName(optionName, colorOptionNames)) {
          colorOptionIndex = index;
        }
      });

      if (colorOptionIndex === -1) return '';

      var firstVariant = deptFindFirstAvailableVariant(productLike.variants);
      if (firstVariant) {
        var optionKey = 'option' + (colorOptionIndex + 1);
        if (firstVariant[optionKey]) {
          return firstVariant[optionKey];
        }
      }

      var optionObj = productLike.options[colorOptionIndex];
      var optionValues = optionObj && optionObj.values ? optionObj.values : [];
      return optionValues.length ? optionValues[0] : '';
    }

    function getColorTokenFromHandle(handle) {
      if (!handle) return '';
      var parts = String(handle).split('-').filter(Boolean);
      if (!parts.length) return '';
      return normalizeToken(parts[parts.length - 1]);
    }

    function formatColorTokenLabel(token) {
      if (!token) return '';
      var withSpaces = token
        .replace(/([a-z])([0-9])/g, '$1 $2')
        .replace(/([0-9])([a-z])/g, '$1 $2');
      return withSpaces.charAt(0).toUpperCase() + withSpaces.slice(1);
    }

    function hydrateCrossProductColorSwitcher(product, callback) {
      var done = function () { if (callback) { callback(); callback = null; } };
      if (!pdpArea || !product || !product.handle) { done(); return; }
      var switcherShell = pdpArea.querySelector('[data-pdp-color-switcher]');
      if (!switcherShell) { done(); return; }

      loadHealixColorGroups(product.handle).then(function (groups) {
        var activeHandle = String(pdpArea.dataset.currentProductHandle || '').trim();
        if (!activeHandle || activeHandle !== String(product.handle || '').trim()) { done(); return; }

        var coreItems = Array.isArray(groups && groups.core) ? groups.core : [];
        var limitedItems = Array.isArray(groups && groups.limited) ? groups.limited : [];
        var uniqueHandles = {};

        coreItems.concat(limitedItems).forEach(function (item) {
          if (!item || !item.handle) return;
          uniqueHandles[item.handle] = true;
        });

        if (Object.keys(uniqueHandles).length <= 1) {
          switcherShell.innerHTML = '';
          done();
          return;
        }

        var colorGroupsHTML = '';
        var coreButtonsHTML = buildHealixColorGroupButtons(coreItems, product.handle);
        var limitedButtonsHTML = buildHealixColorGroupButtons(limitedItems, product.handle);

        if (coreButtonsHTML) {
          colorGroupsHTML += buildHealixColorGroupHTML('CORE', coreButtonsHTML);
        }
        if (limitedButtonsHTML) {
          colorGroupsHTML += buildHealixColorGroupHTML('LIMITED EDITION', limitedButtonsHTML);
        }

        var activeColorLabel = '';
        var allItems = coreItems.concat(limitedItems);
        for (var ci = 0; ci < allItems.length; ci++) {
          if (allItems[ci] && allItems[ci].handle === product.handle) {
            activeColorLabel = allItems[ci].label || '';
            break;
          }
        }
        if (!activeColorLabel) {
          activeColorLabel = getProductColorValue(product) || '';
        }

        var colorLabelHTML = '<span class="dept__pdp-color-label">COLOR: <strong>' + escapeHTML(activeColorLabel) + '</strong></span>';

        switcherShell.innerHTML = colorGroupsHTML
          ? colorLabelHTML + '<div class="dept__pdp-color-groups">' + colorGroupsHTML + '</div>'
          : '';

        var newColorButtons = Array.prototype.slice.call(switcherShell.querySelectorAll('.dept__pdp-color-switch-btn'));
        newColorButtons.forEach(function (button) {
          button.addEventListener('click', function () {
            var targetHandle = button.dataset.productHandle || '';
            if (!targetHandle || targetHandle === product.handle) return;
            fetchPDP(targetHandle);
          });
        });
        done();
      }).catch(function () { done(); });
    }

    function loadHealixColorGroups(handle) {
      var normalizedHandle = String(handle || '').trim();
      if (!normalizedHandle) {
        return Promise.resolve({ core: [], limited: [] });
      }

      var cacheKey = '__groups__' + normalizedHandle;
      if (healixColorSiblingsCache[cacheKey]) {
        return healixColorSiblingsCache[cacheKey];
      }

      healixColorSiblingsCache[cacheKey] = window.HealixColors.colorProductSiblings([normalizedHandle])
        .then(function (payload) {
          var result = payload && payload.result ? payload.result : {};
          return {
            core: normalizeHealixColorGroupEntries(result.core),
            limited: normalizeHealixColorGroupEntries(result.le)
          };
        })
        .catch(function () {
          return { core: [], limited: [] };
        });

      return healixColorSiblingsCache[cacheKey];
    }

    function normalizeHealixColorGroupEntries(entries) {
      if (!Array.isArray(entries) || !entries.length) return [];

      var seenHandles = {};
      var normalizedEntries = [];
      entries.forEach(function (entry) {
        var variant = entry && entry.variant ? entry.variant : {};
        var handle = String(variant.handle || '').trim();
        if (!handle || seenHandles[handle]) return;

        seenHandles[handle] = true;
        var label = String(variant.color || handle || 'Color').replace(/_/g, ' ').trim();
        var hex = String(variant.color_code || '').trim() || '#cccccc';

        var colorKey = normalizeToken(variant.color || handle);
        if (colorKey && hex !== '#cccccc') {
          healixColorCodeCache[colorKey] = hex;
        }

        normalizedEntries.push({
          handle: handle,
          label: label || 'Color',
          hex: hex
        });
      });

      return normalizedEntries;
    }

    function buildHealixColorGroupButtons(items, currentHandle) {
      if (!Array.isArray(items) || !items.length) return '';

      return items.map(function (item) {
        var handle = String(item && item.handle ? item.handle : '').trim();
        if (!handle) return '';

        var label = String(item.label || handle || 'Color').trim();
        var hex = String(item.hex || '#cccccc').trim() || '#cccccc';
        var isActive = handle === currentHandle;
        var buttonClasses = 'dept__pdp-option-btn dept__pdp-swatch-btn dept__pdp-color-switch-btn';
        if (isActive) {
          buttonClasses += ' dept__pdp-option-btn--active dept__pdp-swatch-btn--active';
        }

        return (
          '<button type="button" class="' + buttonClasses + '"' +
            ' data-product-handle="' + escapeHTML(handle) + '"' +
            ' title="' + escapeHTML(label) + '"' +
            ' aria-label="' + escapeHTML('Color: ' + label) + '"' +
            (isActive ? ' aria-current="true"' : '') + '>' +
            '<span class="dept__pdp-swatch-dot" style="--dept-pdp-swatch-color:' + escapeHTML(hex) + ';"></span>' +
          '</button>'
        );
      }).join('');
    }

    function buildHealixColorGroupHTML(groupLabel, buttonsHTML) {
      if (!buttonsHTML) return '';

      return (
        '<div class="dept__pdp-color-group">' +
          '<div class="dept__pdp-color-group-title">' + escapeHTML(groupLabel) + '</div>' +
          '<div class="dept__pdp-variants dept__pdp-variants--swatches dept__pdp-color-switcher">' +
            buttonsHTML +
          '</div>' +
        '</div>'
      );
    }

    function colorSwatchSkeletonHTML() {
      var dotCount = 6;
      var dots = '';
      for (var i = 0; i < dotCount; i++) {
        dots += '<span class="dept__swatch-skeleton-dot"></span>';
      }
      return (
        '<div class="dept__swatch-skeleton">' +
          '<div class="dept__swatch-skeleton-group">' +
            '<span class="dept__swatch-skeleton-label"></span>' +
            '<div class="dept__swatch-skeleton-row">' + dots + '</div>' +
          '</div>' +
          '<div class="dept__swatch-skeleton-group">' +
            '<span class="dept__swatch-skeleton-label"></span>' +
            '<div class="dept__swatch-skeleton-row">' + dots + '</div>' +
          '</div>' +
        '</div>'
      );
    }

    function loadingHTML() {
      return '<div class="dept__loading-skeleton">' +
             Array(4).fill('<div class="dept__skeleton-card"><div class="dept__skeleton-img"></div><div class="dept__skeleton-text"></div><div class="dept__skeleton-text short"></div></div>').join('') +
             '</div>';
    }
    
    function loadingPDPHTML() {
      return '<div class="dept__pdp-mount dept__pdp-mount--loading" data-pdp-mount>' +
             '<div class="dept__loading-skeleton pdp dept__pdp-skeleton-layer">' +
             '<div class="dept__skeleton-gallery">' +
               '<div class="dept__skeleton-thumbs">' +
                 '<div class="dept__skeleton-thumb"></div>' +
                 '<div class="dept__skeleton-thumb"></div>' +
                 '<div class="dept__skeleton-thumb"></div>' +
                 '<div class="dept__skeleton-thumb"></div>' +
               '</div>' +
               '<div class="dept__skeleton-main-img"></div>' +
             '</div>' +
             '<div class="dept__skeleton-info">' +
               '<div class="dept__skeleton-title"></div>' +
               '<div class="dept__skeleton-rating"></div>' +
               '<div class="dept__skeleton-price"></div>' +
               '<div class="dept__skeleton-swatches"></div>' +
               '<div class="dept__skeleton-options"></div>' +
               '<div class="dept__skeleton-options dept__skeleton-options--short"></div>' +
               '<div class="dept__skeleton-size-guide"></div>' +
               '<div class="dept__skeleton-btn"></div>' +
               '<div class="dept__skeleton-badges"></div>' +
               '<div class="dept__skeleton-accordion"></div>' +
               '<div class="dept__skeleton-accordion"></div>' +
               '<div class="dept__skeleton-accordion"></div>' +
               '<div class="dept__skeleton-accordion"></div>' +
             '</div>' +
             '</div></div>';
    }

    function getProductImage(product) {
      if (product.featured_image) return typeof product.featured_image === 'string' ? product.featured_image : product.featured_image.src;
      if (product.images && product.images.length) {
        var first = product.images[0];
        return typeof first === 'string' ? first : first.src;
      }
      return '';
    }

    function getText(container, selector) {
      var node = container.querySelector(selector);
      return node ? node.textContent.trim() : '';
    }

    function formatMoney(rawValue) {
      var money = normalizeMoneyInput(rawValue);
      if (window.formatMoney) {
        return window.formatMoney(money.cents, window.themeMoneyFormat);
      }
      var hasShopifyFormatter = !!(window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.Shopify.money_format);
      if (hasShopifyFormatter) {
        return window.Shopify.formatMoney(money.cents, window.Shopify.money_format);
      }

      if (window.formatMoneyFallback) {
        return window.formatMoneyFallback(money.cents);
      }
      return money.major.toFixed(2);
    }

    function normalizeMoneyInput(rawValue) {
      if (rawValue === null || rawValue === undefined || rawValue === '') {
        return { major: 0, cents: 0, source: 'empty' };
      }

      if (typeof rawValue === 'string') {
        var sanitized = rawValue.replace(/,/g, '').trim();
        var majorFromString = Number(sanitized);
        if (!isFinite(majorFromString)) {
          return { major: 0, cents: 0, source: 'invalid-string' };
        }
        return {
          major: majorFromString,
          cents: Math.round(majorFromString * 100),
          source: 'string-major'
        };
      }

      var numeric = Number(rawValue);
      if (!isFinite(numeric)) {
        return { major: 0, cents: 0, source: 'invalid-number' };
      }

      if (Number.isInteger(numeric) && Math.abs(numeric) >= 1000) {
        return {
          major: numeric / 100,
          cents: Math.round(numeric),
          source: 'number-cents'
        };
      }

      return {
        major: numeric,
        cents: Math.round(numeric * 100),
        source: 'number-major'
      };
    }

    function resizeImage(src, size) {
      if (!src) return '';
      if (typeof src !== 'string') src = src.src || '';
      if (!src) return '';
      var parts = src.split('?');
      var base = parts[0];
      var query = parts[1] ? '?' + parts[1] : '';
      var resized = base.replace(/(\.(jpg|jpeg|png|gif|webp))$/i, '_' + size + 'x$1');
      if (resized === base) return src;
      return resized + query;
    }

    function escapeHTML(str) {
      if (!str) return '';
      var div = document.createElement('div');
      div.textContent = str;
      return div.innerHTML;
    }

    function parseColorOptionNames(rawValue) {
      var base = String(rawValue || '').trim();
      if (!base) {
        return DEFAULT_COLOR_OPTION_NAMES.slice();
      }

      var parsed = base.split(',').map(function (name) {
        return normalizeToken(name);
      }).filter(Boolean);

      return parsed.length ? parsed : DEFAULT_COLOR_OPTION_NAMES.slice();
    }

    function isColorOptionName(optionName, configuredNames) {
      var normalizedOptionName = normalizeToken(optionName);
      if (!normalizedOptionName) return false;
      return configuredNames.indexOf(normalizedOptionName) !== -1;
    }

    function getSwatchHex(optionValue) {
      var key = normalizeToken(optionValue);
      return healixColorCodeCache[key] || '#cccccc';
    }

    function normalizeToken(value) {
      if (value === null || value === undefined) return '';
      return String(value).toLowerCase().trim().replace(/[^a-z0-9]+/g, '');
    }

    function detachScrollProgress(scrollEl) {
      if (!scrollEl || !scrollEl._deptScrollProgress) return;
      var progress = scrollEl._deptScrollProgress;
      if (typeof progress.cleanup === 'function') {
        progress.cleanup();
      } else if (progress.track && progress.track.parentNode) {
        progress.track.parentNode.removeChild(progress.track);
      }
      delete scrollEl._deptScrollProgress;
    }

    function attachScrollProgress(scrollEl) {
      if (!scrollEl || !scrollEl.parentNode) return;
      detachScrollProgress(scrollEl);

      var track = document.createElement('div');
      track.className = 'dept__scroll-progress';
      track.setAttribute('aria-hidden', 'true');
      var thumb = document.createElement('div');
      thumb.className = 'dept__scroll-progress-thumb';
      track.appendChild(thumb);

      scrollEl.parentNode.insertBefore(track, scrollEl.nextSibling);

      function update() {
        var sW = scrollEl.scrollWidth;
        var cW = scrollEl.clientWidth;
        if (sW <= cW + 2) {
          track.classList.remove('is-visible');
          return;
        }
        track.classList.add('is-visible');
        var ratio = cW / sW;
        var thumbW = Math.min(Math.max(ratio * 65, 10), 38);
        thumbW = Math.max(0, Math.min(thumbW, 100));
        var scrollMax = sW - cW;
        var maxLeft = Math.max(0, 100 - thumbW);
        var pos = scrollMax > 0 ? (scrollEl.scrollLeft / scrollMax) * maxLeft : 0;
        pos = Math.max(0, Math.min(pos, maxLeft));
        thumb.style.width = thumbW + '%';
        thumb.style.left = pos + '%';
      }

      scrollEl.addEventListener('scroll', update, { passive: true });
      var ro = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(update) : null;
      if (ro) ro.observe(scrollEl);
      update();
      window.setTimeout(update, 100);

      function cleanup() {
        scrollEl.removeEventListener('scroll', update);
        if (ro) ro.disconnect();
        if (track.parentNode) {
          track.parentNode.removeChild(track);
        }
      }

      scrollEl._deptScrollProgress = { track: track, update: update, cleanup: cleanup };
    }

    function refreshScrollProgress(scrollEl) {
      if (!scrollEl) return;
      if (scrollEl._deptScrollProgress) {
        scrollEl._deptScrollProgress.update();
      } else {
        attachScrollProgress(scrollEl);
      }
    }

    attachScrollProgress(productsRow);

    function refreshVisibleScrollProgress() {
      refreshScrollProgress(productsRow);

      var activeGroup = groups.find(function (g) { return g.classList.contains('is-active'); });
      if (!activeGroup) return;

      var typeTrack = activeGroup.querySelector('.dept__type-cards-track');
      if (typeTrack) {
        refreshScrollProgress(typeTrack);
        detachScrollProgress(activeGroup);
      } else {
        refreshScrollProgress(activeGroup);
      }
    }

    var _origRenderTypeCards = renderTypeCards;
    function renderTypeCardsAndProgress(typeGroups, allProducts, collectionTitle) {
      _origRenderTypeCards(typeGroups, allProducts, collectionTitle);
      refreshVisibleScrollProgress();
    }
    renderTypeCards = renderTypeCardsAndProgress;

    var _origRestoreTypeCards = restoreTypeCards;
    function restoreTypeCardsAndProgress() {
      _origRestoreTypeCards();
      window.setTimeout(refreshVisibleScrollProgress, 50);
    }
    restoreTypeCards = restoreTypeCardsAndProgress;

    var _origAnimateRowReveal = animateRowReveal;
    function animateRowRevealAndProgress(row) {
      _origAnimateRowReveal(row);
      window.setTimeout(refreshVisibleScrollProgress, 50);
    }
    animateRowReveal = animateRowRevealAndProgress;

    var _origSetActiveGroup = setActiveGroup;
    function setActiveGroupAndProgress(groupKey, label, resetDownstream) {
      _origSetActiveGroup(groupKey, label, resetDownstream);
      window.setTimeout(refreshVisibleScrollProgress, 50);
    }
    setActiveGroup = setActiveGroupAndProgress;

    window.setTimeout(refreshVisibleScrollProgress, 120);

  }
})();
